import { defineStore } from 'pinia';
import flagCn from 'flag-icons/flags/4x3/cn.svg';
import flagKh from 'flag-icons/flags/4x3/kh.svg';
import flagLa from 'flag-icons/flags/4x3/la.svg';
import flagTh from 'flag-icons/flags/4x3/th.svg';
import flagTw from 'flag-icons/flags/4x3/tw.svg';
import flagUs from 'flag-icons/flags/4x3/us.svg';
import flagVn from 'flag-icons/flags/4x3/vn.svg';

export const LANGUAGE_STORAGE_KEY = 'jc-web-im-language';

export const languageOptions = [
  { key: 'zh_hans', label: '简体中文', native: '简体中文', menuLabel: '简体中文', flagSrc: flagCn, flagLabel: 'China', htmlLang: 'zh-CN' },
  { key: 'zh_hant', label: '繁體中文', native: '繁體中文', menuLabel: '繁體中文', flagSrc: flagTw, flagLabel: 'Taiwan', htmlLang: 'zh-Hant' },
  { key: 'en', label: 'English', native: 'English', menuLabel: 'English', flagSrc: flagUs, flagLabel: 'United States', htmlLang: 'en' },
  { key: 'km', label: 'ភាសាខ្មែរ', native: 'ភាសាខ្មែរ', menuLabel: 'ខ្មែរ', flagSrc: flagKh, flagLabel: 'Cambodia', htmlLang: 'km' },
  { key: 'lo', label: 'ລາວ', native: 'ລາວ', menuLabel: 'ລາວ', flagSrc: flagLa, flagLabel: 'Laos', htmlLang: 'lo' },
  { key: 'th', label: 'ไทย', native: 'ไทย', menuLabel: 'แบบไทย', flagSrc: flagTh, flagLabel: 'Thailand', htmlLang: 'th' },
  { key: 'vi', label: 'Tiếng Việt', native: 'Tiếng Việt', menuLabel: 'Tiếng Việt', flagSrc: flagVn, flagLabel: 'Vietnam', htmlLang: 'vi' }
];

const messages = {
  zh_hans: {
    'app.subtitle': '连接既有授权 IM 服务的新版 Web 客户端',
    'common.add': '添加',
    'common.cancel': '取消',
    'common.close': '关闭',
    'common.confirm': '确定',
    'common.create': '创建',
    'common.join': '加入',
    'common.language': '语言',
    'common.loading': '正在加载',
    'common.more': '更多',
    'common.refresh': '刷新',
    'common.save': '保存',
    'common.saving': '保存中...',
    'common.search': '搜索',
    'common.send': '发送',
    'common.switchLanguage': '切换语言',
    'common.processing': '处理中...',
    'common.pleaseWait': '请稍候',
    'common.optional': '可选',
    'auth.iconAlt': '{name} 图标',
    'auth.passwordLogin': '密码登录',
    'auth.codeLogin': '验证码登录',
    'auth.phone': '手机号',
    'auth.password': '密码',
    'auth.code': '验证码',
    'auth.loginPassword': '登录密码',
    'auth.confirmPassword': '确认密码',
    'auth.phonePlaceholder': '请输入手机号',
    'auth.passwordPlaceholder': '请输入密码',
    'auth.loginPasswordPlaceholder': '请输入登录密码',
    'auth.confirmPasswordPlaceholder': '请再次输入密码',
    'auth.localCodePlaceholder': '本地测试请输入 666666',
    'auth.smsCodePlaceholder': '请输入短信验证码',
    'auth.codePlaceholder': '请输入验证码',
    'auth.sendCode': '发送验证码',
    'auth.sending': '发送中',
    'auth.login': '登录',
    'auth.loggingIn': '登录中...',
    'auth.register': '注册',
    'auth.registering': '注册中...',
    'auth.newUserRegister': '新用户注册',
    'auth.backToLogin': '返回登录',
    'auth.saveAndEnter': '保存并进入',
    'auth.phoneRegister': '手机号注册',
    'auth.emailRegister': '邮箱注册',
    'auth.usernameRegister': '用户名注册',
    'auth.phoneCountryCode': '手机号国码',
    'auth.email': '邮箱',
    'auth.emailCode': '邮箱验证码',
    'auth.emailPlaceholder': '请输入邮箱',
    'auth.username': '用户名',
    'auth.usernamePlaceholder': '请输入用户名',
    'auth.usernameCountryCode': '用户名注册手机号国码',
    'auth.showCaptcha': '显示验证码',
    'auth.refreshCaptcha': '点击更换验证码',
    'auth.captchaAlt': '6位数字验证码',
    'nav.editProfile': '编辑个人资料',
    'nav.messages': '消息',
    'nav.contacts': '联系人',
    'nav.favorites': '收藏',
    'nav.settings': '设置',
    'nav.logout': '退出登录',
    'settings.title': '设置',
    'settings.menu': '设置菜单',
    'settings.notifications': '通知设置',
    'settings.changePassword': '更改密码',
    'settings.wallet': '钱包管理',
    'settings.language': '切换语言',
    'settings.feedback': '问题反馈',
    'settings.comingSoon': '稍后开放',
    'settings.comingSoonSentence': '该功能稍后开放。',
    'settings.currentPassword': '当前密码',
    'settings.newPassword': '新密码',
    'settings.confirmNewPassword': '确认新密码',
    'settings.savePassword': '保存密码',
    'profile.title': '个人资料',
    'profile.previewAvatar': '预览头像',
    'profile.changeAvatar': '更换头像',
    'profile.nickname': '昵称',
    'profile.userId': '用户ID',
    'profile.avatarPreview': '头像预览',
    'profile.zoomOut': '缩小',
    'profile.zoomIn': '放大',
    'profile.resetZoom': '还原',
    'profile.cropAvatar': '头像预裁切',
    'profile.upload': '上传',
    'profile.loadingImage': '图片加载中',
    'profile.rotateLeft': '左旋90度',
    'profile.rotateRight': '右旋90度',
    'profile.reset': '重置',
    'profile.processing': '处理中...',
    'profile.confirmCrop': '确认裁切',
    'list.unread': '{count} 条未读',
    'list.unreadMessages': '{count} 条未读消息',
    'list.newConversation': '新建会话',
    'list.addContact': '添加联系人',
    'list.createGroup': '新建群组',
    'list.joinGroup': '加入群组',
    'list.broadcast': '群发助手',
    'list.createChannel': '创建频道/公告群',
    'list.searchConversationContact': '搜索会话、联系人',
    'list.noMatches': '没有匹配结果',
    'list.tryAnotherKeyword': '换个关键词再试试',
    'list.noConversations': '暂无会话',
    'list.conversationHint': '收到或发起消息后会出现在这里',
    'list.userKeyword': '用户ID / 手机号 / 用户名',
    'list.userKeywordPlaceholder': '请输入要添加的联系人',
    'list.groupName': '群组名称',
    'list.groupNamePlaceholder': '请输入群组名称',
    'list.groupAnnouncement': '群说明',
    'list.groupWelcome': '欢迎词',
    'list.groupWelcomePlaceholder': '群组创建后自动发送',
    'list.noSelectableContacts': '暂无可选联系人',
    'list.groupKeyword': '群组ID / 群名称',
    'list.groupKeywordPlaceholder': '请输入群组ID或群名称',
    'list.broadcastContent': '群发内容',
    'list.broadcastPlaceholder': '输入要群发的文字',
    'list.channelName': '频道/公告群名称',
    'list.namePlaceholder': '请输入名称',
    'list.channelAnnouncement': '公告说明',
    'contacts.title': '联系人',
    'contacts.count': '{count} 位好友',
    'contacts.search': '搜索联系人',
    'contacts.empty': '暂无联系人',
    'contacts.emptyHint': '好友同步完成后会显示在这里',
    'contacts.adding': '添加中...',
    'contacts.friendRequests': '好友申请',
    'contacts.noFriendRequests': '暂无好友申请',
    'contacts.noFriendRequestsHint': '收到申请后会显示在这里',
    'contacts.applicationFrom': '来自 {userId}',
    'contacts.accept': '同意',
    'contacts.refuse': '拒绝',
    'chat.noConversation': '未选择会话',
    'chat.chooseConversation': '选择一个会话',
    'chat.emptyHint': '真实会话同步完成后，可以在左侧打开聊天',
    'chat.viewGroupMembers': '查看群员',
    'chat.myGroupAlias': '我在本群的昵称',
    'chat.groupManagement': '群组管理',
    'chat.selectedCount': '已选 {count} 条',
    'chat.copy': '复制',
    'chat.delete': '删除',
    'chat.forward': '转发',
    'chat.forwardTo': '转发给',
    'chat.reEdit': '重新编辑',
    'chat.editMessage': '编辑消息',
    'chat.messageDetails': '消息详情',
    'chat.sentAt': '发送时间',
    'chat.editedAt': '编辑时间',
    'chat.sender': '发送人',
    'chat.receiver': '接收人',
    'chat.deliveredAt': '送达时间',
    'chat.readAt': '已读时间',
    'chat.notDelivered': '未送达',
    'chat.unread': '未读',
    'chat.sendFailed': '发送失败',
    'chat.retrySend': '点击重试',
    'chat.confirmTitle': '确认操作',
    'chat.confirmKick': '确认将所选成员移出群组？',
    'chat.confirmLeave': '确认退出该群组？',
    'chat.confirmDismiss': '确认解散该群组？所有成员都将不可继续使用该群。',
    'chat.confirmTransfer': '确认将群主转让给该成员？',
    'chat.removeFromGroup': '移出群组',
    'chat.leaveGroup': '退出群组',
    'chat.dismissGroup': '解散群组',
    'chat.confirmTransferAction': '确认转让',
    'contactProfile.title': '联系人资料', 'contactProfile.phone': '手机号', 'contactProfile.region': '地区', 'contactProfile.unknown': '未知',
    'contactProfile.editRemark': '修改备注', 'contactProfile.saveRemark': '保存备注', 'contactProfile.remarkPlaceholder': '留空使用对方昵称',
    'contactProfile.chooseAction': '请选择处理方式', 'contactProfile.deleteKeep': '删除好友，保留对话', 'contactProfile.deleteRemove': '删除好友，不保留对话',
    'contactProfile.blockKeep': '拉黑好友，保留对话', 'contactProfile.blockRemove': '拉黑好友，不保留对话', 'contactProfile.back': '返回',
    'contactProfile.remarkSaved': '备注名已保存', 'contactProfile.remarkFailed': '备注名修改失败', 'contactProfile.deleteFailed': '删除好友失败', 'contactProfile.blockFailed': '拉黑好友失败',
    'composer.quote': '引用',
    'composer.cancelQuote': '取消引用',
    'composer.emoji': '表情',
    'composer.image': '图片',
    'composer.file': '文件',
    'composer.placeholder': '输入消息',
    'composer.shortcut': 'Enter 发送，Shift + Enter 换行',
    'composer.send': '发送'
  },
  zh_hant: {
    'app.subtitle': '連接既有授權 IM 服務的新版 Web 用戶端',
    'common.add': '新增',
    'common.cancel': '取消',
    'common.close': '關閉',
    'common.confirm': '確定',
    'common.create': '建立',
    'common.join': '加入',
    'common.language': '語言',
    'common.loading': '正在載入',
    'common.more': '更多',
    'common.refresh': '重新整理',
    'common.save': '儲存',
    'common.saving': '儲存中...',
    'common.search': '搜尋',
    'common.send': '傳送',
    'common.switchLanguage': '切換語言',
    'common.processing': '處理中...',
    'common.pleaseWait': '請稍候',
    'common.optional': '選填',
    'auth.iconAlt': '{name} 圖示',
    'auth.passwordLogin': '密碼登入',
    'auth.codeLogin': '驗證碼登入',
    'auth.phone': '手機號',
    'auth.password': '密碼',
    'auth.code': '驗證碼',
    'auth.loginPassword': '登入密碼',
    'auth.confirmPassword': '確認密碼',
    'auth.phonePlaceholder': '請輸入手機號',
    'auth.passwordPlaceholder': '請輸入密碼',
    'auth.loginPasswordPlaceholder': '請輸入登入密碼',
    'auth.confirmPasswordPlaceholder': '請再次輸入密碼',
    'auth.localCodePlaceholder': '本地測試請輸入 666666',
    'auth.smsCodePlaceholder': '請輸入簡訊驗證碼',
    'auth.codePlaceholder': '請輸入驗證碼',
    'auth.sendCode': '傳送驗證碼',
    'auth.sending': '傳送中',
    'auth.login': '登入',
    'auth.loggingIn': '登入中...',
    'auth.register': '註冊',
    'auth.registering': '註冊中...',
    'auth.newUserRegister': '新用戶註冊',
    'auth.backToLogin': '返回登入',
    'auth.saveAndEnter': '儲存並進入',
    'auth.phoneRegister': '手機號註冊',
    'auth.emailRegister': '信箱註冊',
    'auth.usernameRegister': '使用者名稱註冊',
    'auth.phoneCountryCode': '手機國碼',
    'auth.email': '信箱',
    'auth.emailCode': '信箱驗證碼',
    'auth.emailPlaceholder': '請輸入信箱',
    'auth.username': '使用者名稱',
    'auth.usernamePlaceholder': '請輸入使用者名稱',
    'auth.usernameCountryCode': '使用者名稱註冊手機國碼',
    'auth.showCaptcha': '顯示驗證碼',
    'auth.refreshCaptcha': '點擊更換驗證碼',
    'auth.captchaAlt': '6位數字驗證碼',
    'nav.editProfile': '編輯個人資料',
    'nav.messages': '訊息',
    'nav.contacts': '聯絡人',
    'nav.favorites': '收藏',
    'nav.settings': '設定',
    'nav.logout': '登出',
    'settings.title': '設定',
    'settings.menu': '設定選單',
    'settings.notifications': '通知設定',
    'settings.changePassword': '更改密碼',
    'settings.wallet': '錢包管理',
    'settings.language': '切換語言',
    'settings.feedback': '問題回饋',
    'settings.comingSoon': '稍後開放',
    'settings.comingSoonSentence': '該功能稍後開放。',
    'settings.currentPassword': '目前密碼',
    'settings.newPassword': '新密碼',
    'settings.confirmNewPassword': '確認新密碼',
    'settings.savePassword': '儲存密碼',
    'profile.title': '個人資料',
    'profile.previewAvatar': '預覽頭像',
    'profile.changeAvatar': '更換頭像',
    'profile.nickname': '暱稱',
    'profile.userId': '使用者ID',
    'profile.avatarPreview': '頭像預覽',
    'profile.zoomOut': '縮小',
    'profile.zoomIn': '放大',
    'profile.resetZoom': '還原',
    'profile.cropAvatar': '頭像預裁切',
    'profile.upload': '上傳',
    'profile.loadingImage': '圖片載入中',
    'profile.rotateLeft': '左旋90度',
    'profile.rotateRight': '右旋90度',
    'profile.reset': '重設',
    'profile.processing': '處理中...',
    'profile.confirmCrop': '確認裁切',
    'list.unread': '{count} 則未讀',
    'list.unreadMessages': '{count} 則未讀訊息',
    'list.newConversation': '新建會話',
    'list.addContact': '新增聯絡人',
    'list.createGroup': '新建群組',
    'list.joinGroup': '加入群組',
    'list.broadcast': '群發助手',
    'list.createChannel': '建立頻道/公告群',
    'list.searchConversationContact': '搜尋會話、聯絡人',
    'list.noMatches': '沒有符合結果',
    'list.tryAnotherKeyword': '換個關鍵字再試試',
    'list.noConversations': '暫無會話',
    'list.conversationHint': '收到或發起訊息後會出現在這裡',
    'list.userKeyword': '使用者ID / 手機號 / 使用者名稱',
    'list.userKeywordPlaceholder': '請輸入要新增的聯絡人',
    'list.groupName': '群組名稱',
    'list.groupNamePlaceholder': '請輸入群組名稱',
    'list.groupAnnouncement': '群說明',
    'list.groupWelcome': '歡迎詞',
    'list.groupWelcomePlaceholder': '群組建立後自動傳送',
    'list.noSelectableContacts': '暫無可選聯絡人',
    'list.groupKeyword': '群組ID / 群名稱',
    'list.groupKeywordPlaceholder': '請輸入群組ID或群名稱',
    'list.broadcastContent': '群發內容',
    'list.broadcastPlaceholder': '輸入要群發的文字',
    'list.channelName': '頻道/公告群名稱',
    'list.namePlaceholder': '請輸入名稱',
    'list.channelAnnouncement': '公告說明',
    'contacts.title': '聯絡人',
    'contacts.count': '{count} 位好友',
    'contacts.search': '搜尋聯絡人',
    'contacts.empty': '暫無聯絡人',
    'contacts.emptyHint': '好友同步完成後會顯示在這裡',
    'contacts.adding': '新增中...',
    'contacts.friendRequests': '好友申請',
    'contacts.noFriendRequests': '暫無好友申請',
    'contacts.noFriendRequestsHint': '收到申請後會顯示在這裡',
    'contacts.applicationFrom': '來自 {userId}',
    'contacts.accept': '同意',
    'contacts.refuse': '拒絕',
    'chat.noConversation': '未選擇會話',
    'chat.chooseConversation': '選擇一個會話',
    'chat.emptyHint': '真實會話同步完成後，可以在左側開啟聊天',
    'chat.viewGroupMembers': '查看群員',
    'chat.myGroupAlias': '我在本群的暱稱',
    'chat.groupManagement': '群組管理',
    'chat.selectedCount': '已選 {count} 則',
    'chat.copy': '複製',
    'chat.delete': '刪除',
    'chat.forward': '轉發',
    'chat.forwardTo': '轉發給',
    'chat.reEdit': '重新編輯',
    'chat.editMessage': '編輯訊息',
    'chat.messageDetails': '訊息詳情',
    'chat.sentAt': '傳送時間',
    'chat.editedAt': '編輯時間',
    'chat.sender': '傳送人',
    'chat.receiver': '接收人',
    'chat.deliveredAt': '送達時間',
    'chat.readAt': '已讀時間',
    'chat.notDelivered': '未送達',
    'chat.unread': '未讀',
    'chat.sendFailed': '傳送失敗',
    'chat.retrySend': '點擊重試',
    'chat.confirmTitle': '確認操作',
    'chat.confirmKick': '確認將所選成員移出群組？',
    'chat.confirmLeave': '確認退出該群組？',
    'chat.confirmDismiss': '確認解散該群組？所有成員都將不可繼續使用該群。',
    'chat.confirmTransfer': '確認將群主轉讓給該成員？',
    'chat.removeFromGroup': '移出群組',
    'chat.leaveGroup': '退出群組',
    'chat.dismissGroup': '解散群組',
    'chat.confirmTransferAction': '確認轉讓',
    'contactProfile.title': '聯絡人資料', 'contactProfile.phone': '手機號', 'contactProfile.region': '地區', 'contactProfile.unknown': '未知',
    'contactProfile.editRemark': '修改備註', 'contactProfile.saveRemark': '儲存備註', 'contactProfile.remarkPlaceholder': '留空則使用對方暱稱',
    'contactProfile.chooseAction': '請選擇處理方式', 'contactProfile.deleteKeep': '刪除好友，保留對話', 'contactProfile.deleteRemove': '刪除好友，不保留對話',
    'contactProfile.blockKeep': '封鎖好友，保留對話', 'contactProfile.blockRemove': '封鎖好友，不保留對話', 'contactProfile.back': '返回',
    'contactProfile.remarkSaved': '備註已儲存', 'contactProfile.remarkFailed': '修改備註失敗', 'contactProfile.deleteFailed': '刪除好友失敗', 'contactProfile.blockFailed': '封鎖好友失敗',
    'composer.quote': '引用',
    'composer.cancelQuote': '取消引用',
    'composer.emoji': '表情',
    'composer.image': '圖片',
    'composer.file': '檔案',
    'composer.placeholder': '輸入訊息',
    'composer.shortcut': 'Enter 傳送，Shift + Enter 換行',
    'composer.send': '傳送'
  },
  en: {
    'app.subtitle': 'New web client connected to the authorized IM service',
    'common.add': 'Add',
    'common.cancel': 'Cancel',
    'common.close': 'Close',
    'common.confirm': 'OK',
    'common.create': 'Create',
    'common.join': 'Join',
    'common.language': 'Language',
    'common.loading': 'Loading',
    'common.more': 'More',
    'common.refresh': 'Refresh',
    'common.save': 'Save',
    'common.saving': 'Saving...',
    'common.search': 'Search',
    'common.send': 'Send',
    'common.switchLanguage': 'Switch language',
    'common.processing': 'Processing...',
    'common.pleaseWait': 'Please wait',
    'common.optional': 'Optional',
    'auth.iconAlt': '{name} icon',
    'auth.passwordLogin': 'Password',
    'auth.codeLogin': 'Code',
    'auth.phone': 'Phone number',
    'auth.password': 'Password',
    'auth.code': 'Code',
    'auth.loginPassword': 'Login password',
    'auth.confirmPassword': 'Confirm password',
    'auth.phonePlaceholder': 'Enter phone number',
    'auth.passwordPlaceholder': 'Enter password',
    'auth.loginPasswordPlaceholder': 'Enter login password',
    'auth.confirmPasswordPlaceholder': 'Enter password again',
    'auth.localCodePlaceholder': 'Use 666666 for local test',
    'auth.smsCodePlaceholder': 'Enter SMS code',
    'auth.codePlaceholder': 'Enter code',
    'auth.sendCode': 'Send code',
    'auth.sending': 'Sending',
    'auth.login': 'Log in',
    'auth.loggingIn': 'Logging in...',
    'auth.register': 'Register',
    'auth.registering': 'Registering...',
    'auth.newUserRegister': 'Create account',
    'auth.backToLogin': 'Back to login',
    'auth.saveAndEnter': 'Save and enter',
    'auth.phoneRegister': 'Phone',
    'auth.emailRegister': 'Email',
    'auth.usernameRegister': 'Username',
    'auth.phoneCountryCode': 'Phone country code',
    'auth.email': 'Email',
    'auth.emailCode': 'Email code',
    'auth.emailPlaceholder': 'Enter email',
    'auth.username': 'Username',
    'auth.usernamePlaceholder': 'Enter username',
    'auth.usernameCountryCode': 'Username registration phone country code',
    'auth.showCaptcha': 'Show code',
    'auth.refreshCaptcha': 'Refresh code',
    'auth.captchaAlt': '6-digit captcha',
    'nav.editProfile': 'Edit profile',
    'nav.messages': 'Messages',
    'nav.contacts': 'Contacts',
    'nav.favorites': 'Favorites',
    'nav.settings': 'Settings',
    'nav.logout': 'Log out',
    'settings.title': 'Settings',
    'settings.menu': 'Settings menu',
    'settings.notifications': 'Notifications',
    'settings.changePassword': 'Change password',
    'settings.wallet': 'Wallet',
    'settings.language': 'Language',
    'settings.feedback': 'Feedback',
    'settings.comingSoon': 'Soon',
    'settings.comingSoonSentence': 'This feature will be available later.',
    'settings.currentPassword': 'Current password',
    'settings.newPassword': 'New password',
    'settings.confirmNewPassword': 'Confirm new password',
    'settings.savePassword': 'Save password',
    'profile.title': 'Profile',
    'profile.previewAvatar': 'Preview avatar',
    'profile.changeAvatar': 'Change avatar',
    'profile.nickname': 'Nickname',
    'profile.userId': 'User ID',
    'profile.avatarPreview': 'Avatar preview',
    'profile.zoomOut': 'Zoom out',
    'profile.zoomIn': 'Zoom in',
    'profile.resetZoom': 'Reset',
    'profile.cropAvatar': 'Crop avatar',
    'profile.upload': 'Upload',
    'profile.loadingImage': 'Loading image',
    'profile.rotateLeft': 'Rotate left 90°',
    'profile.rotateRight': 'Rotate right 90°',
    'profile.reset': 'Reset',
    'profile.processing': 'Processing...',
    'profile.confirmCrop': 'Confirm crop',
    'list.unread': '{count} unread',
    'list.unreadMessages': '{count} unread messages',
    'list.newConversation': 'New chat',
    'list.addContact': 'Add contact',
    'list.createGroup': 'Create group',
    'list.joinGroup': 'Join group',
    'list.broadcast': 'Broadcast',
    'list.createChannel': 'Create channel',
    'list.searchConversationContact': 'Search chats or contacts',
    'list.noMatches': 'No matches',
    'list.tryAnotherKeyword': 'Try another keyword',
    'list.noConversations': 'No conversations',
    'list.conversationHint': 'Messages you receive or start will appear here',
    'list.userKeyword': 'User ID / phone / username',
    'list.userKeywordPlaceholder': 'Enter the contact to add',
    'list.groupName': 'Group name',
    'list.groupNamePlaceholder': 'Enter group name',
    'list.groupAnnouncement': 'Group description',
    'list.groupWelcome': 'Welcome message',
    'list.groupWelcomePlaceholder': 'Sent after group creation',
    'list.noSelectableContacts': 'No contacts available',
    'list.groupKeyword': 'Group ID / name',
    'list.groupKeywordPlaceholder': 'Enter group ID or name',
    'list.broadcastContent': 'Broadcast content',
    'list.broadcastPlaceholder': 'Enter broadcast text',
    'list.channelName': 'Channel name',
    'list.namePlaceholder': 'Enter name',
    'list.channelAnnouncement': 'Announcement',
    'contacts.title': 'Contacts',
    'contacts.count': '{count} friends',
    'contacts.search': 'Search contacts',
    'contacts.empty': 'No contacts',
    'contacts.emptyHint': 'Synced friends will appear here',
    'contacts.adding': 'Adding...',
    'contacts.friendRequests': 'Friend requests',
    'contacts.noFriendRequests': 'No friend requests',
    'contacts.noFriendRequestsHint': 'New requests will appear here',
    'contacts.applicationFrom': 'From {userId}',
    'contacts.accept': 'Accept',
    'contacts.refuse': 'Decline',
    'chat.noConversation': 'No conversation selected',
    'chat.chooseConversation': 'Choose a conversation',
    'chat.emptyHint': 'After sync, open a chat from the left side',
    'chat.viewGroupMembers': 'View members',
    'chat.myGroupAlias': 'My group nickname',
    'chat.groupManagement': 'Group management',
    'chat.selectedCount': '{count} selected',
    'chat.copy': 'Copy',
    'chat.delete': 'Delete',
    'chat.forward': 'Forward',
    'chat.forwardTo': 'Forward to',
    'chat.reEdit': 'Edit again',
    'chat.editMessage': 'Edit message',
    'chat.messageDetails': 'Message details',
    'chat.sentAt': 'Sent at',
    'chat.editedAt': 'Edited at',
    'chat.sender': 'Sender',
    'chat.receiver': 'Receiver',
    'chat.deliveredAt': 'Delivered at',
    'chat.readAt': 'Read at',
    'chat.notDelivered': 'Not delivered',
    'chat.unread': 'Unread',
    'chat.sendFailed': 'Failed to send',
    'chat.retrySend': 'Click to retry',
    'chat.confirmTitle': 'Confirm action',
    'chat.confirmKick': 'Remove the selected members from this group?',
    'chat.confirmLeave': 'Leave this group?',
    'chat.confirmDismiss': 'Dismiss this group? Members will no longer be able to use it.',
    'chat.confirmTransfer': 'Transfer group ownership to this member?',
    'chat.removeFromGroup': 'Remove',
    'chat.leaveGroup': 'Leave group',
    'chat.dismissGroup': 'Dismiss group',
    'chat.confirmTransferAction': 'Transfer',
    'contactProfile.title': 'Contact profile', 'contactProfile.phone': 'Phone', 'contactProfile.region': 'Region', 'contactProfile.unknown': 'Unknown',
    'contactProfile.editRemark': 'Edit remark', 'contactProfile.saveRemark': 'Save remark', 'contactProfile.remarkPlaceholder': 'Leave blank to use their nickname',
    'contactProfile.chooseAction': 'Choose an action', 'contactProfile.deleteKeep': 'Delete friend, keep chat', 'contactProfile.deleteRemove': 'Delete friend and chat',
    'contactProfile.blockKeep': 'Block friend, keep chat', 'contactProfile.blockRemove': 'Block friend and delete chat', 'contactProfile.back': 'Back',
    'contactProfile.remarkSaved': 'Remark saved', 'contactProfile.remarkFailed': 'Failed to update remark', 'contactProfile.deleteFailed': 'Failed to delete friend', 'contactProfile.blockFailed': 'Failed to block friend',
    'composer.quote': 'Quote',
    'composer.cancelQuote': 'Cancel quote',
    'composer.emoji': 'Emoji',
    'composer.image': 'Image',
    'composer.file': 'File',
    'composer.placeholder': 'Type a message',
    'composer.shortcut': 'Enter to send, Shift + Enter for new line',
    'composer.send': 'Send'
  },
  km: {
    'app.subtitle': 'ម៉ាស៊ីនភ្ញៀវ Web IM ថ្មី',
    'common.cancel': 'បោះបង់',
    'common.close': 'បិទ',
    'common.save': 'រក្សាទុក',
    'common.saving': 'កំពុងរក្សាទុក...',
    'common.search': 'ស្វែងរក',
    'common.send': 'ផ្ញើ',
    'common.switchLanguage': 'ប្តូរភាសា',
    'common.processing': 'កំពុងដំណើរការ...',
    'auth.passwordLogin': 'ចូលដោយពាក្យសម្ងាត់',
    'auth.codeLogin': 'ចូលដោយកូដ',
    'auth.phone': 'លេខទូរស័ព្ទ',
    'auth.password': 'ពាក្យសម្ងាត់',
    'auth.code': 'កូដ',
    'auth.login': 'ចូល',
    'auth.loggingIn': 'កំពុងចូល...',
    'auth.register': 'ចុះឈ្មោះ',
    'auth.newUserRegister': 'ចុះឈ្មោះអ្នកប្រើថ្មី',
    'auth.backToLogin': 'ត្រឡប់ទៅចូល',
    'nav.messages': 'សារ',
    'nav.contacts': 'ទំនាក់ទំនង',
    'nav.favorites': 'ចំណូលចិត្ត',
    'nav.settings': 'ការកំណត់',
    'nav.logout': 'ចេញ',
    'profile.nickname': 'ឈ្មោះហៅក្រៅ',
    'profile.userId': 'លេខសម្គាល់អ្នកប្រើ',
    'contacts.title': 'ទំនាក់ទំនង',
    'contacts.friendRequests': 'សំណើមិត្តភក្តិ',
    'contacts.noFriendRequests': 'មិនមានសំណើទេ',
    'contacts.noFriendRequestsHint': 'សំណើថ្មីនឹងបង្ហាញនៅទីនេះ',
    'contacts.applicationFrom': 'ពី {userId}',
    'contacts.accept': 'យល់ព្រម',
    'contacts.refuse': 'បដិសេធ',
    'chat.noConversation': 'មិនទាន់ជ្រើសរើសការសន្ទនា',
    'chat.chooseConversation': 'ជ្រើសរើសការសន្ទនា',
    'chat.delete': 'លុប',
    'chat.sendFailed': 'ផ្ញើសារមិនបាន',
    'chat.retrySend': 'ចុចដើម្បីផ្ញើម្តងទៀត',
    'contactProfile.title': 'ព័ត៌មានទំនាក់ទំនង', 'contactProfile.phone': 'លេខទូរស័ព្ទ', 'contactProfile.region': 'តំបន់', 'contactProfile.unknown': 'មិនស្គាល់',
    'contactProfile.editRemark': 'កែឈ្មោះសម្គាល់', 'contactProfile.saveRemark': 'រក្សាទុកឈ្មោះសម្គាល់', 'contactProfile.remarkPlaceholder': 'ទុកទទេដើម្បីប្រើឈ្មោះរបស់ពួកគេ',
    'contactProfile.chooseAction': 'ជ្រើសរើសវិធីដោះស្រាយ', 'contactProfile.deleteKeep': 'លុបមិត្តភក្តិ រក្សាការសន្ទនា', 'contactProfile.deleteRemove': 'លុបមិត្តភក្តិ និងការសន្ទនា',
    'contactProfile.blockKeep': 'រារាំងមិត្តភក្តិ រក្សាការសន្ទនា', 'contactProfile.blockRemove': 'រារាំងមិត្តភក្តិ និងលុបការសន្ទនា', 'contactProfile.back': 'ត្រឡប់',
    'contactProfile.remarkSaved': 'បានរក្សាទុកឈ្មោះសម្គាល់', 'contactProfile.remarkFailed': 'កែឈ្មោះសម្គាល់មិនបាន', 'contactProfile.deleteFailed': 'លុបមិត្តភក្តិមិនបាន', 'contactProfile.blockFailed': 'រារាំងមិត្តភក្តិមិនបាន',
    'composer.placeholder': 'វាយសារ',
    'composer.send': 'ផ្ញើ'
  },
  lo: {
    'app.subtitle': 'ເວັບ IM ເວີຊັນໃໝ່',
    'common.cancel': 'ຍົກເລີກ',
    'common.close': 'ປິດ',
    'common.save': 'ບັນທຶກ',
    'common.saving': 'ກຳລັງບັນທຶກ...',
    'common.search': 'ຄົ້ນຫາ',
    'common.send': 'ສົ່ງ',
    'common.switchLanguage': 'ປ່ຽນພາສາ',
    'common.processing': 'ກຳລັງດຳເນີນການ...',
    'auth.passwordLogin': 'ເຂົ້າລະບົບດ້ວຍລະຫັດ',
    'auth.codeLogin': 'ເຂົ້າດ້ວຍລະຫັດ OTP',
    'auth.phone': 'ເບີໂທ',
    'auth.password': 'ລະຫັດຜ່ານ',
    'auth.code': 'ລະຫັດ',
    'auth.login': 'ເຂົ້າລະບົບ',
    'auth.loggingIn': 'ກຳລັງເຂົ້າ...',
    'auth.register': 'ລົງທະບຽນ',
    'auth.newUserRegister': 'ລົງທະບຽນໃໝ່',
    'auth.backToLogin': 'ກັບໄປເຂົ້າ',
    'nav.messages': 'ຂໍ້ຄວາມ',
    'nav.contacts': 'ຕິດຕໍ່',
    'nav.favorites': 'ມັກ',
    'nav.settings': 'ຕັ້ງຄ່າ',
    'nav.logout': 'ອອກ',
    'profile.nickname': 'ຊື່ຫຼິ້ນ',
    'profile.userId': 'ລະຫັດຜູ້ໃຊ້',
    'contacts.title': 'ຕິດຕໍ່',
    'contacts.friendRequests': 'ຄຳຂໍເປັນໝູ່',
    'contacts.noFriendRequests': 'ບໍ່ມີຄຳຂໍ',
    'contacts.noFriendRequestsHint': 'ຄຳຂໍໃໝ່ຈະສະແດງຢູ່ນີ້',
    'contacts.applicationFrom': 'ຈາກ {userId}',
    'contacts.accept': 'ຍອມຮັບ',
    'contacts.refuse': 'ປະຕິເສດ',
    'chat.noConversation': 'ຍັງບໍ່ໄດ້ເລືອກສົນທະນາ',
    'chat.chooseConversation': 'ເລືອກສົນທະນາ',
    'chat.delete': 'ລຶບ',
    'chat.sendFailed': 'ສົ່ງຂໍ້ຄວາມບໍ່ສຳເລັດ',
    'chat.retrySend': 'ຄລິກເພື່ອລອງສົ່ງອີກຄັ້ງ',
    'contactProfile.title': 'ຂໍ້ມູນຜູ້ຕິດຕໍ່', 'contactProfile.phone': 'ເບີໂທ', 'contactProfile.region': 'ພື້ນທີ່', 'contactProfile.unknown': 'ບໍ່ຮູ້',
    'contactProfile.editRemark': 'ແກ້ໄຂຊື່ໝາຍເຫດ', 'contactProfile.saveRemark': 'ບັນທຶກຊື່ໝາຍເຫດ', 'contactProfile.remarkPlaceholder': 'ປ່ອຍຫວ່າງເພື່ອໃຊ້ຊື່ຂອງເຂົາ',
    'contactProfile.chooseAction': 'ເລືອກວິທີຈັດການ', 'contactProfile.deleteKeep': 'ລຶບໝູ່ ແຕ່ເກັບການສົນທະນາ', 'contactProfile.deleteRemove': 'ລຶບໝູ່ແລະການສົນທະນາ',
    'contactProfile.blockKeep': 'ບລັອກໝູ່ ແຕ່ເກັບການສົນທະນາ', 'contactProfile.blockRemove': 'ບລັອກໝູ່ແລະລຶບການສົນທະນາ', 'contactProfile.back': 'ກັບຄືນ',
    'contactProfile.remarkSaved': 'ບັນທຶກແລ້ວ', 'contactProfile.remarkFailed': 'ແກ້ໄຂບໍ່ສຳເລັດ', 'contactProfile.deleteFailed': 'ລຶບໝູ່ບໍ່ສຳເລັດ', 'contactProfile.blockFailed': 'ບລັອກໝູ່ບໍ່ສຳເລັດ',
    'composer.placeholder': 'ພິມຂໍ້ຄວາມ',
    'composer.send': 'ສົ່ງ'
  },
  th: {
    'app.subtitle': 'เว็บไคลเอนต์ IM รุ่นใหม่',
    'common.cancel': 'ยกเลิก',
    'common.close': 'ปิด',
    'common.save': 'บันทึก',
    'common.saving': 'กำลังบันทึก...',
    'common.search': 'ค้นหา',
    'common.send': 'ส่ง',
    'common.switchLanguage': 'เปลี่ยนภาษา',
    'common.processing': 'กำลังดำเนินการ...',
    'auth.passwordLogin': 'เข้าสู่ระบบด้วยรหัสผ่าน',
    'auth.codeLogin': 'เข้าสู่ระบบด้วยรหัส',
    'auth.phone': 'เบอร์โทร',
    'auth.password': 'รหัสผ่าน',
    'auth.code': 'รหัส',
    'auth.login': 'เข้าสู่ระบบ',
    'auth.loggingIn': 'กำลังเข้าสู่ระบบ...',
    'auth.register': 'สมัครสมาชิก',
    'auth.newUserRegister': 'สมัครผู้ใช้ใหม่',
    'auth.backToLogin': 'กลับไปเข้าสู่ระบบ',
    'nav.messages': 'ข้อความ',
    'nav.contacts': 'รายชื่อ',
    'nav.favorites': 'รายการโปรด',
    'nav.settings': 'ตั้งค่า',
    'nav.logout': 'ออกจากระบบ',
    'profile.nickname': 'ชื่อเล่น',
    'profile.userId': 'รหัสผู้ใช้',
    'contacts.title': 'รายชื่อ',
    'contacts.friendRequests': 'คำขอเป็นเพื่อน',
    'contacts.noFriendRequests': 'ไม่มีคำขอเป็นเพื่อน',
    'contacts.noFriendRequestsHint': 'คำขอใหม่จะแสดงที่นี่',
    'contacts.applicationFrom': 'จาก {userId}',
    'contacts.accept': 'ยอมรับ',
    'contacts.refuse': 'ปฏิเสธ',
    'chat.noConversation': 'ยังไม่ได้เลือกแชท',
    'chat.chooseConversation': 'เลือกแชท',
    'chat.delete': 'ลบ',
    'chat.sendFailed': 'ส่งข้อความไม่สำเร็จ',
    'chat.retrySend': 'คลิกเพื่อลองส่งอีกครั้ง',
    'contactProfile.title': 'ข้อมูลผู้ติดต่อ', 'contactProfile.phone': 'เบอร์โทร', 'contactProfile.region': 'ภูมิภาค', 'contactProfile.unknown': 'ไม่ทราบ',
    'contactProfile.editRemark': 'แก้ไขชื่อหมายเหตุ', 'contactProfile.saveRemark': 'บันทึกชื่อหมายเหตุ', 'contactProfile.remarkPlaceholder': 'เว้นว่างเพื่อใช้ชื่อเล่นของอีกฝ่าย',
    'contactProfile.chooseAction': 'เลือกวิธีดำเนินการ', 'contactProfile.deleteKeep': 'ลบเพื่อน เก็บแชทไว้', 'contactProfile.deleteRemove': 'ลบเพื่อนและลบแชท',
    'contactProfile.blockKeep': 'บล็อกเพื่อน เก็บแชทไว้', 'contactProfile.blockRemove': 'บล็อกเพื่อนและลบแชท', 'contactProfile.back': 'กลับ',
    'contactProfile.remarkSaved': 'บันทึกแล้ว', 'contactProfile.remarkFailed': 'แก้ไขไม่สำเร็จ', 'contactProfile.deleteFailed': 'ลบเพื่อนไม่สำเร็จ', 'contactProfile.blockFailed': 'บล็อกเพื่อนไม่สำเร็จ',
    'composer.placeholder': 'พิมพ์ข้อความ',
    'composer.send': 'ส่ง'
  },
  vi: {
    'app.subtitle': 'Ứng dụng Web IM phiên bản mới',
    'common.cancel': 'Hủy',
    'common.close': 'Đóng',
    'common.save': 'Lưu',
    'common.saving': 'Đang lưu...',
    'common.search': 'Tìm kiếm',
    'common.send': 'Gửi',
    'common.switchLanguage': 'Đổi ngôn ngữ',
    'common.processing': 'Đang xử lý...',
    'auth.passwordLogin': 'Đăng nhập mật khẩu',
    'auth.codeLogin': 'Đăng nhập mã',
    'auth.phone': 'Số điện thoại',
    'auth.password': 'Mật khẩu',
    'auth.code': 'Mã',
    'auth.login': 'Đăng nhập',
    'auth.loggingIn': 'Đang đăng nhập...',
    'auth.register': 'Đăng ký',
    'auth.newUserRegister': 'Đăng ký người dùng mới',
    'auth.backToLogin': 'Quay lại đăng nhập',
    'nav.messages': 'Tin nhắn',
    'nav.contacts': 'Liên hệ',
    'nav.favorites': 'Yêu thích',
    'nav.settings': 'Cài đặt',
    'nav.logout': 'Đăng xuất',
    'profile.nickname': 'Biệt danh',
    'profile.userId': 'ID người dùng',
    'contacts.title': 'Liên hệ',
    'contacts.friendRequests': 'Lời mời kết bạn',
    'contacts.noFriendRequests': 'Không có lời mời',
    'contacts.noFriendRequestsHint': 'Lời mời mới sẽ hiển thị ở đây',
    'contacts.applicationFrom': 'Từ {userId}',
    'contacts.accept': 'Đồng ý',
    'contacts.refuse': 'Từ chối',
    'chat.noConversation': 'Chưa chọn cuộc trò chuyện',
    'chat.chooseConversation': 'Chọn cuộc trò chuyện',
    'chat.delete': 'Xóa',
    'chat.sendFailed': 'Gửi tin nhắn thất bại',
    'chat.retrySend': 'Nhấn để gửi lại',
    'contactProfile.title': 'Thông tin liên hệ', 'contactProfile.phone': 'Số điện thoại', 'contactProfile.region': 'Khu vực', 'contactProfile.unknown': 'Không rõ',
    'contactProfile.editRemark': 'Sửa tên ghi chú', 'contactProfile.saveRemark': 'Lưu tên ghi chú', 'contactProfile.remarkPlaceholder': 'Để trống để dùng biệt danh của họ',
    'contactProfile.chooseAction': 'Chọn cách xử lý', 'contactProfile.deleteKeep': 'Xóa bạn, giữ cuộc trò chuyện', 'contactProfile.deleteRemove': 'Xóa bạn và cuộc trò chuyện',
    'contactProfile.blockKeep': 'Chặn bạn, giữ cuộc trò chuyện', 'contactProfile.blockRemove': 'Chặn bạn và xóa cuộc trò chuyện', 'contactProfile.back': 'Quay lại',
    'contactProfile.remarkSaved': 'Đã lưu ghi chú', 'contactProfile.remarkFailed': 'Không thể sửa ghi chú', 'contactProfile.deleteFailed': 'Không thể xóa bạn', 'contactProfile.blockFailed': 'Không thể chặn bạn',
    'composer.placeholder': 'Nhập tin nhắn',
    'composer.send': 'Gửi'
  }
};

const appUpdateMessages = {
  zh_hans: { updateAvailable: '页面已更新，请刷新后继续使用，避免消息发送失败。', refreshNow: '立即刷新' },
  zh_hant: { updateAvailable: '頁面已有更新，請重新整理後繼續使用，以免訊息傳送失敗。', refreshNow: '立即重新整理' },
  en: { updateAvailable: 'An update is available. Refresh before continuing to avoid message delivery failures.', refreshNow: 'Refresh now' },
  km: { updateAvailable: 'មានកំណែថ្មី។ សូមផ្ទុកទំព័រឡើងវិញមុនបន្ត ដើម្បីជៀសវាងការផ្ញើសារបរាជ័យ។', refreshNow: 'ផ្ទុកឡើងវិញឥឡូវ' },
  lo: { updateAvailable: 'ມີໜ້າເວັບລຸ້ນໃໝ່ ກະລຸນາໂຫຼດໜ້າຄືນກ່ອນໃຊ້ຕໍ່ ເພື່ອຫຼີກລ້ຽງການສົ່ງຂໍ້ຄວາມລົ້ມເຫຼວ.', refreshNow: 'ໂຫຼດຄືນດຽວນີ້' },
  th: { updateAvailable: 'มีหน้าเว็บเวอร์ชันใหม่ โปรดรีเฟรชก่อนใช้งานต่อเพื่อป้องกันการส่งข้อความล้มเหลว', refreshNow: 'รีเฟรชตอนนี้' },
  vi: { updateAvailable: 'Trang đã có bản cập nhật. Hãy tải lại trước khi tiếp tục để tránh gửi tin nhắn thất bại.', refreshNow: 'Tải lại ngay' }
};
Object.entries(appUpdateMessages).forEach(([locale, values]) => {
  Object.entries(values).forEach(([key, value]) => {
    messages[locale][`app.${key}`] = value;
  });
});

const authenticationMessages = {
  zh_hans: '当前登录已失效，请重新登录。',
  zh_hant: '目前登入已失效，請重新登入。',
  en: 'Your session is no longer valid. Please sign in again.',
  km: 'សម័យចូលរបស់អ្នកលែងមានសុពលភាព។ សូមចូលម្តងទៀត។',
  lo: 'ສະຖານະການເຂົ້າລະບົບໝົດອາຍຸແລ້ວ ກະລຸນາເຂົ້າລະບົບໃໝ່.',
  th: 'สถานะการเข้าสู่ระบบหมดอายุแล้ว โปรดเข้าสู่ระบบอีกครั้ง',
  vi: 'Phiên đăng nhập đã hết hiệu lực. Vui lòng đăng nhập lại.'
};
Object.entries(authenticationMessages).forEach(([locale, value]) => {
  messages[locale]['auth.sessionExpired'] = value;
});

const connectionFailureMessages = {
  zh_hans: '连接服务失败，请检查网络后重试。',
  zh_hant: '連線服務失敗，請檢查網路後再試。',
  en: 'Unable to connect to the service. Check your network and try again.',
  km: 'មិនអាចភ្ជាប់ទៅសេវាបានទេ។ សូមពិនិត្យបណ្ដាញ ហើយព្យាយាមម្ដងទៀត។',
  lo: 'ບໍ່ສາມາດເຊື່ອມຕໍ່ບໍລິການໄດ້ ກະລຸນາກວດສອບເຄືອຂ່າຍແລ້ວລອງໃໝ່.',
  th: 'ไม่สามารถเชื่อมต่อบริการได้ โปรดตรวจสอบเครือข่ายแล้วลองอีกครั้ง',
  vi: 'Không thể kết nối dịch vụ. Vui lòng kiểm tra mạng rồi thử lại.'
};
Object.entries(connectionFailureMessages).forEach(([locale, value]) => {
  messages[locale]['auth.connectionFailed'] = value;
});

const groupReceiptMessages = {
  zh_hans: {
    read: '已读', undelivered: '未送达', members: '成员', memberCount: '{count} 人', deliveredLabel: '送达',
    noReadMembers: '暂无已读成员', noUnreadMembers: '暂无未读成员', noUndeliveredMembers: '暂无未送达成员',
    localDetailUnavailable: '本地临时消息暂无送达/已读详情', receiptSenderOnly: '只有消息发送人可以查看群消息回执详情', receiptDetailUnavailable: '群消息回执详情暂时无法加载'
  },
  zh_hant: {
    read: '已讀', undelivered: '未送達', members: '成員', memberCount: '{count} 人', deliveredLabel: '送達',
    noReadMembers: '暫無已讀成員', noUnreadMembers: '暫無未讀成員', noUndeliveredMembers: '暫無未送達成員',
    localDetailUnavailable: '本機暫存訊息暫無送達／已讀詳情', receiptSenderOnly: '只有訊息傳送人可以查看群組訊息回執詳情', receiptDetailUnavailable: '群組訊息回執詳情暫時無法載入'
  },
  en: {
    read: 'Read', undelivered: 'Undelivered', members: 'Members', memberCount: '{count}', deliveredLabel: 'Delivered',
    noReadMembers: 'No members have read this message', noUnreadMembers: 'No unread members', noUndeliveredMembers: 'No undelivered members',
    localDetailUnavailable: 'Delivery and read details are unavailable for a local pending message', receiptSenderOnly: 'Only the sender can view group message receipts', receiptDetailUnavailable: 'Group message receipt details are temporarily unavailable'
  },
  km: {
    read: 'បានអាន', undelivered: 'មិនទាន់បញ្ជូនដល់', members: 'សមាជិក', memberCount: '{count} នាក់', deliveredLabel: 'បានបញ្ជូនដល់',
    noReadMembers: 'មិនទាន់មានសមាជិកបានអាន', noUnreadMembers: 'មិនមានសមាជិកមិនទាន់អាន', noUndeliveredMembers: 'មិនមានសមាជិកមិនទាន់បញ្ជូនដល់',
    localDetailUnavailable: 'សារមូលដ្ឋានបណ្តោះអាសន្នមិនមានព័ត៌មានបញ្ជូនដល់/បានអាន', receiptSenderOnly: 'មានតែអ្នកផ្ញើប៉ុណ្ណោះដែលអាចមើលបង្កាន់ដៃសារក្រុម', receiptDetailUnavailable: 'មិនអាចផ្ទុកព័ត៌មានបង្កាន់ដៃសារក្រុមបានបណ្តោះអាសន្ន'
  },
  lo: {
    read: 'ອ່ານແລ້ວ', undelivered: 'ຍັງບໍ່ສົ່ງເຖິງ', members: 'ສະມາຊິກ', memberCount: '{count} ຄົນ', deliveredLabel: 'ສົ່ງເຖິງ',
    noReadMembers: 'ຍັງບໍ່ມີສະມາຊິກອ່ານ', noUnreadMembers: 'ບໍ່ມີສະມາຊິກທີ່ຍັງບໍ່ອ່ານ', noUndeliveredMembers: 'ບໍ່ມີສະມາຊິກທີ່ຍັງບໍ່ສົ່ງເຖິງ',
    localDetailUnavailable: 'ຂໍ້ຄວາມຊົ່ວຄາວບໍ່ມີລາຍລະອຽດການສົ່ງ/ອ່ານ', receiptSenderOnly: 'ມີພຽງຜູ້ສົ່ງທີ່ເບິ່ງສະຖານະຂໍ້ຄວາມກຸ່ມໄດ້', receiptDetailUnavailable: 'ບໍ່ສາມາດໂຫຼດລາຍລະອຽດສະຖານະຂໍ້ຄວາມກຸ່ມໄດ້ຊົ່ວຄາວ'
  },
  th: {
    read: 'อ่านแล้ว', undelivered: 'ยังไม่ส่งถึง', members: 'สมาชิก', memberCount: '{count} คน', deliveredLabel: 'ส่งถึง',
    noReadMembers: 'ยังไม่มีสมาชิกอ่าน', noUnreadMembers: 'ไม่มีสมาชิกที่ยังไม่อ่าน', noUndeliveredMembers: 'ไม่มีสมาชิกที่ยังไม่ส่งถึง',
    localDetailUnavailable: 'ข้อความชั่วคราวในเครื่องยังไม่มีรายละเอียดการส่งถึง/อ่าน', receiptSenderOnly: 'เฉพาะผู้ส่งเท่านั้นที่ดูสถานะข้อความกลุ่มได้', receiptDetailUnavailable: 'ไม่สามารถโหลดรายละเอียดสถานะข้อความกลุ่มได้ชั่วคราว'
  },
  vi: {
    read: 'Đã đọc', undelivered: 'Chưa chuyển đến', members: 'Thành viên', memberCount: '{count} người', deliveredLabel: 'Đã chuyển đến',
    noReadMembers: 'Chưa có thành viên đã đọc', noUnreadMembers: 'Không có thành viên chưa đọc', noUndeliveredMembers: 'Không có thành viên chưa nhận được',
    localDetailUnavailable: 'Tin nhắn tạm trên máy chưa có chi tiết đã chuyển/đã đọc', receiptSenderOnly: 'Chỉ người gửi mới có thể xem trạng thái tin nhắn nhóm', receiptDetailUnavailable: 'Tạm thời không thể tải chi tiết trạng thái tin nhắn nhóm'
  }
};
Object.entries(groupReceiptMessages).forEach(([locale, values]) => {
  Object.entries(values).forEach(([key, value]) => {
    messages[locale][`chat.${key}`] = value;
  });
});

const groupPanelMessages = {
  zh_hans: ['群概况','群名','群ID','群说明','未设置','群主昵称','解散群组','转让群组','退出群组','群组管理','群员','群主','暂无群员','我在本群的昵称','昵称','留空使用个人昵称','暂无可转让成员','确认转让','管理员设置','修改群资料','群员管理','禁言设置','暂无可设置成员','保存管理员','群名称','欢迎词','保存资料','添加群员','暂无可添加联系人','添加所选群员','移除群员','管理员','暂无可移除成员','移出群组','单一群员禁言','请选择群员','禁言分钟数（0为解除）','保存单员禁言','禁言模式','关闭禁言','全体禁言包含管理员','除管理员外全体禁言','时段类型','立即禁言直到管理解除','单次','每天固定时段','开始','结束','保存禁言'],
  zh_hant: ['群組概況','群名','群組ID','群組說明','未設定','群主暱稱','解散群組','轉讓群組','退出群組','群組管理','群組成員','群主','暫無群組成員','我在本群的暱稱','暱稱','留空則使用個人暱稱','暫無可轉讓成員','確認轉讓','管理員設定','修改群組資料','成員管理','禁言設定','暫無可設定成員','儲存管理員','群組名稱','歡迎詞','儲存資料','新增成員','暫無可新增的聯絡人','新增所選成員','移除成員','管理員','暫無可移除成員','移出群組','單一成員禁言','請選擇成員','禁言分鐘數（0為解除）','儲存單人禁言','禁言模式','關閉禁言','全體禁言包含管理員','除管理員外全體禁言','時段類型','立即禁言直到管理員解除','單次','每天固定時段','開始','結束','儲存禁言'],
  en: ['Group overview','Group name','Group ID','Description','Not set','Owner nickname','Disband group','Transfer group','Leave group','Group management','Members','Owner','No members','My group nickname','Nickname','Leave blank to use your profile nickname','No members available for transfer','Confirm transfer','Administrators','Edit group profile','Member management','Mute settings','No eligible members','Save administrators','Group name','Welcome message','Save profile','Add members','No contacts available to add','Add selected members','Remove members','Administrator','No members available to remove','Remove from group','Mute one member','Select a member','Mute duration in minutes (0 to unmute)','Save member mute','Mute mode','Turn off muting','Mute everyone including administrators','Mute everyone except administrators','Schedule type','Mute now until manually disabled','One-time','Daily fixed period','Start','End','Save mute settings'],
  km: ['ទិដ្ឋភាពទូទៅនៃក្រុម','ឈ្មោះក្រុម','លេខសម្គាល់ក្រុម','ការពិពណ៌នា','មិនទាន់កំណត់','ឈ្មោះម្ចាស់ក្រុម','រំសាយក្រុម','ផ្ទេរក្រុម','ចាកចេញពីក្រុម','ការគ្រប់គ្រងក្រុម','សមាជិក','ម្ចាស់ក្រុម','មិនមានសមាជិក','ឈ្មោះខ្ញុំក្នុងក្រុម','ឈ្មោះហៅក្រៅ','ទុកទទេដើម្បីប្រើឈ្មោះប្រវត្តិរូប','មិនមានសមាជិកសម្រាប់ផ្ទេរ','បញ្ជាក់ការផ្ទេរ','អ្នកគ្រប់គ្រង','កែព័ត៌មានក្រុម','គ្រប់គ្រងសមាជិក','ការកំណត់បិទសំឡេង','មិនមានសមាជិកសមស្រប','រក្សាទុកអ្នកគ្រប់គ្រង','ឈ្មោះក្រុម','សារស្វាគមន៍','រក្សាទុកព័ត៌មាន','បន្ថែមសមាជិក','មិនមានទំនាក់ទំនងអាចបន្ថែម','បន្ថែមសមាជិកដែលបានជ្រើស','ដកសមាជិក','អ្នកគ្រប់គ្រង','មិនមានសមាជិកអាចដក','ដកចេញពីក្រុម','បិទសំឡេងសមាជិកម្នាក់','ជ្រើសរើសសមាជិក','រយៈពេលបិទសំឡេងជានាទី (0 ដើម្បីដោះ)','រក្សាទុកការបិទសំឡេង','របៀបបិទសំឡេង','បិទការហាមនិយាយ','បិទសំឡេងគ្រប់គ្នារួមទាំងអ្នកគ្រប់គ្រង','បិទសំឡេងគ្រប់គ្នាលើកលែងអ្នកគ្រប់គ្រង','ប្រភេទកាលវិភាគ','បិទសំឡេងឥឡូវរហូតដល់បិទដោយដៃ','ម្តង','រៀងរាល់ថ្ងៃតាមពេលកំណត់','ចាប់ផ្តើម','បញ្ចប់','រក្សាទុកការកំណត់'],
  lo: ['ພາບລວມກຸ່ມ','ຊື່ກຸ່ມ','ID ກຸ່ມ','ຄຳອະທິບາຍ','ຍັງບໍ່ໄດ້ຕັ້ງ','ຊື່ຫົວໜ້າກຸ່ມ','ຍຸບກຸ່ມ','ໂອນກຸ່ມ','ອອກຈາກກຸ່ມ','ຈັດການກຸ່ມ','ສະມາຊິກ','ຫົວໜ້າກຸ່ມ','ບໍ່ມີສະມາຊິກ','ຊື່ຂ້ອຍໃນກຸ່ມ','ຊື່ຫຼິ້ນ','ປ່ອຍຫວ່າງເພື່ອໃຊ້ຊື່ໂປຣໄຟລ໌','ບໍ່ມີສະມາຊິກສຳລັບໂອນ','ຢືນຢັນການໂອນ','ຜູ້ດູແລ','ແກ້ໄຂຂໍ້ມູນກຸ່ມ','ຈັດການສະມາຊິກ','ຕັ້ງຄ່າປິດສຽງ','ບໍ່ມີສະມາຊິກທີ່ເໝາະສົມ','ບັນທຶກຜູ້ດູແລ','ຊື່ກຸ່ມ','ຂໍ້ຄວາມຕ້ອນຮັບ','ບັນທຶກຂໍ້ມູນ','ເພີ່ມສະມາຊິກ','ບໍ່ມີລາຍຊື່ຕິດຕໍ່ໃຫ້ເພີ່ມ','ເພີ່ມສະມາຊິກທີ່ເລືອກ','ລຶບສະມາຊິກ','ຜູ້ດູແລ','ບໍ່ມີສະມາຊິກໃຫ້ລຶບ','ນຳອອກຈາກກຸ່ມ','ປິດສຽງສະມາຊິກຄົນດຽວ','ເລືອກສະມາຊິກ','ໄລຍະປິດສຽງເປັນນາທີ (0 ເພື່ອຍົກເລີກ)','ບັນທຶກການປິດສຽງ','ໂໝດປິດສຽງ','ປິດການຫ້າມເວົ້າ','ປິດສຽງທຸກຄົນລວມຜູ້ດູແລ','ປິດສຽງທຸກຄົນຍົກເວັ້ນຜູ້ດູແລ','ປະເພດຕາຕະລາງ','ປິດສຽງທັນທີຈົນກວ່າຈະປິດເອງ','ຄັ້ງດຽວ','ຊ່ວງເວລາຄົງທີ່ທຸກມື້','ເລີ່ມ','ສິ້ນສຸດ','ບັນທຶກການຕັ້ງຄ່າ'],
  th: ['ภาพรวมกลุ่ม','ชื่อกลุ่ม','รหัสกลุ่ม','คำอธิบาย','ยังไม่ได้ตั้งค่า','ชื่อเล่นเจ้าของกลุ่ม','ยุบกลุ่ม','โอนกลุ่ม','ออกจากกลุ่ม','จัดการกลุ่ม','สมาชิก','เจ้าของกลุ่ม','ไม่มีสมาชิก','ชื่อของฉันในกลุ่ม','ชื่อเล่น','เว้นว่างเพื่อใช้ชื่อจากโปรไฟล์','ไม่มีสมาชิกที่โอนได้','ยืนยันการโอน','ผู้ดูแล','แก้ไขข้อมูลกลุ่ม','จัดการสมาชิก','ตั้งค่าปิดเสียง','ไม่มีสมาชิกที่กำหนดได้','บันทึกผู้ดูแล','ชื่อกลุ่ม','ข้อความต้อนรับ','บันทึกข้อมูล','เพิ่มสมาชิก','ไม่มีรายชื่อติดต่อให้เพิ่ม','เพิ่มสมาชิกที่เลือก','ลบสมาชิก','ผู้ดูแล','ไม่มีสมาชิกให้ลบ','นำออกจากกลุ่ม','ปิดเสียงสมาชิกรายคน','เลือกสมาชิก','ระยะเวลาปิดเสียงเป็นนาที (0 เพื่อยกเลิก)','บันทึกการปิดเสียงสมาชิก','โหมดปิดเสียง','ปิดการห้ามพูด','ปิดเสียงทุกคนรวมผู้ดูแล','ปิดเสียงทุกคนยกเว้นผู้ดูแล','ประเภทกำหนดเวลา','ปิดเสียงทันทีจนกว่าจะยกเลิกเอง','ครั้งเดียว','ช่วงเวลาคงที่ทุกวัน','เริ่ม','สิ้นสุด','บันทึกการตั้งค่าปิดเสียง'],
  vi: ['Tổng quan nhóm','Tên nhóm','ID nhóm','Mô tả','Chưa thiết lập','Biệt danh chủ nhóm','Giải tán nhóm','Chuyển nhượng nhóm','Rời nhóm','Quản lý nhóm','Thành viên','Chủ nhóm','Chưa có thành viên','Biệt danh của tôi trong nhóm','Biệt danh','Để trống để dùng biệt danh hồ sơ','Không có thành viên để chuyển nhượng','Xác nhận chuyển nhượng','Quản trị viên','Sửa thông tin nhóm','Quản lý thành viên','Cài đặt tắt tiếng','Không có thành viên phù hợp','Lưu quản trị viên','Tên nhóm','Lời chào','Lưu thông tin','Thêm thành viên','Không có liên hệ để thêm','Thêm thành viên đã chọn','Xóa thành viên','Quản trị viên','Không có thành viên để xóa','Xóa khỏi nhóm','Tắt tiếng một thành viên','Chọn thành viên','Thời gian tắt tiếng theo phút (0 để bỏ tắt tiếng)','Lưu tắt tiếng thành viên','Chế độ tắt tiếng','Tắt chế độ im lặng','Tắt tiếng tất cả kể cả quản trị viên','Tắt tiếng tất cả trừ quản trị viên','Loại lịch','Tắt tiếng ngay đến khi quản trị viên hủy','Một lần','Khung giờ cố định hằng ngày','Bắt đầu','Kết thúc','Lưu cài đặt tắt tiếng']
};

const groupPanelKeys = ['overview','name','id','description','notSet','ownerAlias','dismiss','transfer','leave','management','members','owner','emptyMembers','myAlias','alias','aliasPlaceholder','transferEmpty','confirmTransfer','adminSettings','editProfile','memberManagement','muteSettings','noAdminCandidates','saveAdmins','groupName','welcome','saveProfile','addMembers','noContacts','addSelected','removeMembers','admin','noRemoveCandidates','removeSelected','singleMute','selectMember','muteMinutes','saveSingleMute','muteMode','muteOff','muteAllIncludingAdmins','muteAllExceptAdmins','scheduleType','scheduleManual','scheduleOnce','scheduleDaily','start','end','saveMute'];
Object.entries(groupPanelMessages).forEach(([locale, values]) => {
  groupPanelKeys.forEach((key, index) => { messages[locale][`groupPanel.${key}`] = values[index]; });
});

const groupMessageActionMessages = {
  zh_hans: {
    messageSettings: '消息时限',
    recallMinutes: '可撤回时间（分钟）',
    editMinutes: '可编辑时间（分钟）',
    messageTimeHint: '仅作用于当前群组；0 表示无时间限制，最大可设置 525600 分钟。',
    saveMessageSettings: '保存消息时限',
    useGlobalMessageSettings: '恢复全局设置',
    messageSettingsSaved: '当前群组的消息时限已保存',
    messageSettingsFailed: '群消息时限保存失败',
    globalMessageSettingsRestored: '当前群组已恢复使用全局消息时限',
    globalMessageSettingsRestoreFailed: '恢复全局消息时限失败',
    messageTimeInvalid: '请输入 0 至 525600 之间的整数分钟数'
  },
  zh_hant: {
    messageSettings: '訊息時限',
    recallMinutes: '可撤回時間（分鐘）',
    editMinutes: '可編輯時間（分鐘）',
    messageTimeHint: '僅套用於目前群組；0 表示無時間限制，最多可設定 525600 分鐘。',
    saveMessageSettings: '儲存訊息時限',
    useGlobalMessageSettings: '恢復全域設定',
    messageSettingsSaved: '目前群組的訊息時限已儲存',
    messageSettingsFailed: '群組訊息時限儲存失敗',
    globalMessageSettingsRestored: '目前群組已恢復使用全域訊息時限',
    globalMessageSettingsRestoreFailed: '恢復全域訊息時限失敗',
    messageTimeInvalid: '請輸入 0 至 525600 之間的整數分鐘數'
  },
  en: {
    messageSettings: 'Message limits',
    recallMinutes: 'Recall window (minutes)',
    editMinutes: 'Edit window (minutes)',
    messageTimeHint: 'Applies only to this group. Use 0 for no time limit; maximum 525600 minutes.',
    saveMessageSettings: 'Save message limits',
    useGlobalMessageSettings: 'Use global settings',
    messageSettingsSaved: 'Message limits for this group have been saved',
    messageSettingsFailed: 'Failed to save group message limits',
    globalMessageSettingsRestored: 'This group now uses the global message limits',
    globalMessageSettingsRestoreFailed: 'Failed to restore the global message limits',
    messageTimeInvalid: 'Enter a whole number from 0 to 525600'
  }
};
Object.entries(groupMessageActionMessages).forEach(([locale, values]) => {
  Object.entries(values).forEach(([key, value]) => {
    messages[locale][`groupPanel.${key}`] = value;
  });
});

const conversationToolMessages = {
  zh_hans: {
    back: '返回', title: '聊天设置', searchMessages: '搜索消息', contactInfo: '联系人信息', groupInfo: '群组信息',
    searchPlaceholder: '搜索当前聊天记录', searchCount: '找到 {count} 条', searchPrompt: '搜索聊天记录', searchHint: '输入文字、发送者或附件名称，可搜索完整本地历史记录。', noSearchResults: '没有找到消息', tryAnotherKeyword: '请更换关键词再试。', searchFailed: '聊天记录搜索失败',
    groupConversation: '群组聊天', singleConversation: '单人聊天', editContact: '编辑联系人资料', selectMessages: '选择消息',
    mute: '静音通知', unmute: '开启通知', on: '已开启', off: '未开启', mutedSaved: '该聊天已静音', unmutedSaved: '该聊天已恢复通知', muteFailed: '通知设置失败',
    addSpecial: '添加到“特别关注”', removeSpecial: '移出“特别关注”', specialAdded: '已添加到“特别关注”', specialRemoved: '已移出“特别关注”', specialFailed: '特别关注设置失败',
    exportHtml: '导出对话记录', exporting: '正在整理完整历史并内嵌附件，请保持页面开启……', exported: '已导出 {count} 条对话记录，内嵌 {attachments} 个附件，可完全离线阅读', exportFailed: '对话记录导出失败',
    disappearingMessages: '限时消息', destructOff: '关闭', destructOneDay: '1 天', destructSevenDays: '7 天', destructNinetyDays: '90 天', destructSaved: '限时消息设置已保存', destructFailed: '限时消息设置失败',
    closeChat: '关闭聊天', clearChat: '清空聊天', deleteChat: '删除聊天', block: '拉黑',
    confirmClose: '关闭后会从会话列表隐藏，收到新消息时仍可再次出现。确认关闭？', closeFailed: '关闭聊天失败',
    confirmClear: '将清除当前账号设备与服务器上的该聊天消息，操作无法撤销。确认清空？', cleared: '聊天记录已清空', clearFailed: '清空聊天失败',
    confirmDelete: '将删除会话及全部聊天消息，操作无法撤销。确认删除？', deleteFailed: '删除聊天失败',
    confirmBlock: '拉黑后将无法继续正常收发对方消息，现有对话会保留。确认拉黑？', blocked: '联系人已拉黑',
    me: '我', otherParty: '对方', recalledMessage: '已撤回消息', image: '图片', file: '文件', unsupportedMessage: '暂不支持预览的消息'
  },
  zh_hant: {
    back: '返回', title: '聊天設定', searchMessages: '搜尋訊息', contactInfo: '聯絡人資訊', groupInfo: '群組資訊',
    searchPlaceholder: '搜尋目前聊天記錄', searchCount: '找到 {count} 則', searchPrompt: '搜尋聊天記錄', searchHint: '輸入文字、傳送者或附件名稱，可搜尋完整本機歷史記錄。', noSearchResults: '找不到訊息', tryAnotherKeyword: '請更換關鍵字再試。', searchFailed: '聊天記錄搜尋失敗',
    groupConversation: '群組聊天', singleConversation: '單人聊天', editContact: '編輯聯絡人資料', selectMessages: '選擇訊息',
    mute: '靜音通知', unmute: '開啟通知', on: '已開啟', off: '未開啟', mutedSaved: '此聊天已靜音', unmutedSaved: '此聊天已恢復通知', muteFailed: '通知設定失敗',
    addSpecial: '加入「特別關注」', removeSpecial: '移出「特別關注」', specialAdded: '已加入「特別關注」', specialRemoved: '已移出「特別關注」', specialFailed: '特別關注設定失敗',
    exportHtml: '匯出對話記錄', exporting: '正在整理完整歷史並內嵌附件，請保持頁面開啟……', exported: '已匯出 {count} 則對話記錄，內嵌 {attachments} 個附件，可完全離線閱讀', exportFailed: '對話記錄匯出失敗',
    disappearingMessages: '限時訊息', destructOff: '關閉', destructOneDay: '1 天', destructSevenDays: '7 天', destructNinetyDays: '90 天', destructSaved: '限時訊息設定已儲存', destructFailed: '限時訊息設定失敗',
    closeChat: '關閉聊天', clearChat: '清空聊天', deleteChat: '刪除聊天', block: '封鎖',
    confirmClose: '關閉後會從會話清單隱藏，收到新訊息時仍可再次出現。確認關閉？', closeFailed: '關閉聊天失敗',
    confirmClear: '將清除目前帳號裝置與伺服器上的聊天訊息，無法復原。確認清空？', cleared: '聊天記錄已清空', clearFailed: '清空聊天失敗',
    confirmDelete: '將刪除會話及全部聊天訊息，無法復原。確認刪除？', deleteFailed: '刪除聊天失敗',
    confirmBlock: '封鎖後將無法繼續正常收發對方訊息，現有對話會保留。確認封鎖？', blocked: '聯絡人已封鎖',
    me: '我', otherParty: '對方', recalledMessage: '已撤回訊息', image: '圖片', file: '檔案', unsupportedMessage: '暫不支援預覽的訊息'
  },
  en: {
    back: 'Back', title: 'Chat settings', searchMessages: 'Search messages', contactInfo: 'Contact info', groupInfo: 'Group info',
    searchPlaceholder: 'Search this chat', searchCount: '{count} found', searchPrompt: 'Search chat history', searchHint: 'Search the full local history by text, sender, or attachment name.', noSearchResults: 'No messages found', tryAnotherKeyword: 'Try another keyword.', searchFailed: 'Failed to search chat history',
    groupConversation: 'Group chat', singleConversation: 'Direct chat', editContact: 'Edit contact', selectMessages: 'Select messages',
    mute: 'Mute notifications', unmute: 'Enable notifications', on: 'On', off: 'Off', mutedSaved: 'Notifications muted', unmutedSaved: 'Notifications enabled', muteFailed: 'Failed to update notifications',
    addSpecial: 'Add to special attention', removeSpecial: 'Remove from special attention', specialAdded: 'Added to special attention', specialRemoved: 'Removed from special attention', specialFailed: 'Failed to update special attention',
    exportHtml: 'Export chat history', exporting: 'Preparing the complete history and embedding attachments. Keep this page open…', exported: 'Exported {count} messages with {attachments} embedded attachments for fully offline reading', exportFailed: 'Failed to export chat history',
    disappearingMessages: 'Disappearing messages', destructOff: 'Off', destructOneDay: '1 day', destructSevenDays: '7 days', destructNinetyDays: '90 days', destructSaved: 'Disappearing message setting saved', destructFailed: 'Failed to save disappearing message setting',
    closeChat: 'Close chat', clearChat: 'Clear chat', deleteChat: 'Delete chat', block: 'Block',
    confirmClose: 'This chat will be hidden and can reappear when a new message arrives. Close it?', closeFailed: 'Failed to close chat',
    confirmClear: 'This clears the chat messages for the current account and cannot be undone. Clear this chat?', cleared: 'Chat history cleared', clearFailed: 'Failed to clear chat',
    confirmDelete: 'This deletes the chat and all messages and cannot be undone. Delete this chat?', deleteFailed: 'Failed to delete chat',
    confirmBlock: 'Blocking prevents normal messaging with this contact. Existing chat history will remain. Block this contact?', blocked: 'Contact blocked',
    me: 'Me', otherParty: 'Other party', recalledMessage: 'Recalled message', image: 'Image', file: 'File', unsupportedMessage: 'Unsupported message'
  }
};
Object.entries(conversationToolMessages).forEach(([locale, values]) => {
  Object.entries(values).forEach(([key, value]) => {
    messages[locale][`conversationTools.${key}`] = value;
  });
});

const botMotherMessages = {
  zh_hans: {
    managerTitle:'BotMother 机器人管理',back:'返回',description:'创建新的机器人账号，并管理你现有机器人的 Token 与状态。',searchPlaceholder:'搜索机器人',myBots:'我的机器人',createNew:'创建新机器人',limitReached:'已达到每人 {count} 个机器人的上限',createHint:'设置名称和唯一用户名',active:'运行中',revoked:'Token 已撤销',noResults:'没有匹配的机器人',tryAnother:'请更换关键词再试。',noBots:'还没有机器人',noBotsHint:'点击“创建新机器人”开始建立。',createTitle:'创建机器人',createDescription:'填写显示名称与公开用户名。创建成功后 Token 只显示一次。',displayName:'显示名称',displayNamePlaceholder:'例如：订单通知助手',displayNameHint:'1–64 个可见字符。',username:'机器人用户名',usernamePlaceholder:'order_notice_bot',usernameHint:'7–32 个英文字母、数字或下划线，必须以 bot 结尾。',botUserId:'机器人用户 ID',tokenStatus:'Token 状态',createdAt:'创建时间',newToken:'新的机器人 Token',tokenOnce:'Token 只在建立或重新签发时显示，请立即复制并安全保存在服务端。',copyToken:'复制 Token',rotateConfirmTitle:'重新签发 Token？',rotateConfirmText:'旧 Token 将立即失效，使用旧 Token 的服务会停止工作。',revokeConfirmTitle:'撤销 Token？',revokeConfirmText:'撤销后机器人无法调用 API，之后可重新签发。',rotateToken:'重新签发 Token',issueToken:'签发新 Token',revokeToken:'撤销 Token',sessionExpired:'登录状态已失效，请重新登录。',usernameExists:'这个机器人用户名已被使用。',limitError:'已达到机器人数量上限。',notFound:'没有找到这个机器人。',validationError:'请检查机器人名称与用户名格式。',requestFailed:'机器人管理服务暂时无法处理请求。',invalidDisplayName:'机器人名称需为 1–64 个可见字符。',invalidUsername:'用户名需为 7–32 个英文字母、数字或下划线，并以 bot 结尾。',created:'机器人已建立，请立即保存 Token。',tokenIssued:'新 Token 已签发，旧 Token 已失效。',tokenRevoked:'Token 已撤销。',tokenCopied:'Token 已复制。',copyFailed:'Token 复制失败，请手动选择复制。',openManager:'打开 BotMother 机器人管理',open:'机器人管理'
  },
  zh_hant: {
    managerTitle:'BotMother 機器人管理',back:'返回',description:'建立新的機器人帳號，並管理現有機器人的 Token 與狀態。',searchPlaceholder:'搜尋機器人',myBots:'我的機器人',createNew:'建立新機器人',limitReached:'已達到每人 {count} 個機器人的上限',createHint:'設定名稱和唯一使用者名稱',active:'運作中',revoked:'Token 已撤銷',noResults:'找不到符合的機器人',tryAnother:'請更換關鍵字再試。',noBots:'尚未建立機器人',noBotsHint:'點擊「建立新機器人」開始。',createTitle:'建立機器人',createDescription:'填寫顯示名稱與公開使用者名稱。建立成功後 Token 只顯示一次。',displayName:'顯示名稱',displayNamePlaceholder:'例如：訂單通知助手',displayNameHint:'1–64 個可見字元。',username:'機器人使用者名稱',usernamePlaceholder:'order_notice_bot',usernameHint:'7–32 個英文字母、數字或底線，必須以 bot 結尾。',botUserId:'機器人使用者 ID',tokenStatus:'Token 狀態',createdAt:'建立時間',newToken:'新的機器人 Token',tokenOnce:'Token 只在建立或重新簽發時顯示，請立即複製並安全保存在伺服器端。',copyToken:'複製 Token',rotateConfirmTitle:'重新簽發 Token？',rotateConfirmText:'舊 Token 將立即失效，使用舊 Token 的服務會停止運作。',revokeConfirmTitle:'撤銷 Token？',revokeConfirmText:'撤銷後機器人無法呼叫 API，之後可重新簽發。',rotateToken:'重新簽發 Token',issueToken:'簽發新 Token',revokeToken:'撤銷 Token',sessionExpired:'登入狀態已失效，請重新登入。',usernameExists:'這個機器人使用者名稱已被使用。',limitError:'已達到機器人數量上限。',notFound:'找不到這個機器人。',validationError:'請檢查機器人名稱與使用者名稱格式。',requestFailed:'機器人管理服務暫時無法處理請求。',invalidDisplayName:'機器人名稱需為 1–64 個可見字元。',invalidUsername:'使用者名稱需為 7–32 個英文字母、數字或底線，並以 bot 結尾。',created:'機器人已建立，請立即保存 Token。',tokenIssued:'新 Token 已簽發，舊 Token 已失效。',tokenRevoked:'Token 已撤銷。',tokenCopied:'Token 已複製。',copyFailed:'Token 複製失敗，請手動選取複製。',openManager:'開啟 BotMother 機器人管理',open:'機器人管理'
  },
  en: {
    managerTitle:'BotMother bot manager',back:'Back',description:'Create bot accounts and manage the tokens and status of your existing bots.',searchPlaceholder:'Search bots',myBots:'My bots',createNew:'Create a new bot',limitReached:'You have reached the limit of {count} bots',createHint:'Choose a name and unique username',active:'Active',revoked:'Token revoked',noResults:'No matching bots',tryAnother:'Try another search.',noBots:'No bots yet',noBotsHint:'Select “Create a new bot” to get started.',createTitle:'Create a bot',createDescription:'Enter a display name and public username. The token is shown only once after creation.',displayName:'Display name',displayNamePlaceholder:'For example: Order notifier',displayNameHint:'1–64 visible characters.',username:'Bot username',usernamePlaceholder:'order_notice_bot',usernameHint:'7–32 letters, numbers, or underscores and must end in bot.',botUserId:'Bot user ID',tokenStatus:'Token status',createdAt:'Created',newToken:'New bot token',tokenOnce:'This token is shown only when created or reissued. Copy it now and keep it on your server.',copyToken:'Copy token',rotateConfirmTitle:'Reissue token?',rotateConfirmText:'The old token stops working immediately, including every service still using it.',revokeConfirmTitle:'Revoke token?',revokeConfirmText:'The bot cannot call the API after revocation. You can reissue a token later.',rotateToken:'Reissue token',issueToken:'Issue new token',revokeToken:'Revoke token',sessionExpired:'Your session has expired. Sign in again.',usernameExists:'This bot username is already in use.',limitError:'You have reached the bot limit.',notFound:'This bot could not be found.',validationError:'Check the bot name and username format.',requestFailed:'The bot management service cannot process this request right now.',invalidDisplayName:'The bot name must contain 1–64 visible characters.',invalidUsername:'The username must contain 7–32 letters, numbers, or underscores and end in bot.',created:'Bot created. Save the token now.',tokenIssued:'A new token was issued and the old token is no longer valid.',tokenRevoked:'The token was revoked.',tokenCopied:'Token copied.',copyFailed:'Could not copy the token. Select and copy it manually.',openManager:'Open BotMother bot manager',open:'Manage bots'
  },
  km: {
    managerTitle:'គ្រប់គ្រង BotMother',back:'ត្រឡប់',description:'បង្កើតគណនី bot និងគ្រប់គ្រង Token និងស្ថានភាព bot របស់អ្នក។',searchPlaceholder:'ស្វែងរក bot',myBots:'Bot របស់ខ្ញុំ',createNew:'បង្កើត bot ថ្មី',limitReached:'បានដល់កំណត់ {count} bot',createHint:'កំណត់ឈ្មោះ និងឈ្មោះអ្នកប្រើតែមួយ',active:'កំពុងដំណើរការ',revoked:'បានដក Token',noResults:'រកមិនឃើញ bot',tryAnother:'សូមសាកពាក្យផ្សេង។',noBots:'មិនទាន់មាន bot',noBotsHint:'ចុច “បង្កើត bot ថ្មី” ដើម្បីចាប់ផ្តើម។',createTitle:'បង្កើត bot',createDescription:'បញ្ចូលឈ្មោះបង្ហាញ និងឈ្មោះអ្នកប្រើសាធារណៈ។ Token បង្ហាញតែម្តង។',displayName:'ឈ្មោះបង្ហាញ',displayNamePlaceholder:'ឧ. ជំនួយការជូនដំណឹង',displayNameHint:'1–64 តួអក្សរ។',username:'ឈ្មោះអ្នកប្រើ bot',usernamePlaceholder:'order_notice_bot',usernameHint:'7–32 អក្សរ លេខ ឬសញ្ញា _ និងត្រូវបញ្ចប់ដោយ bot។',botUserId:'ID អ្នកប្រើ bot',tokenStatus:'ស្ថានភាព Token',createdAt:'ពេលបង្កើត',newToken:'Token bot ថ្មី',tokenOnce:'Token បង្ហាញតែពេលបង្កើត ឬចេញថ្មី។ សូមចម្លង និងរក្សាទុកលើ server។',copyToken:'ចម្លង Token',rotateConfirmTitle:'ចេញ Token ថ្មី?',rotateConfirmText:'Token ចាស់នឹងឈប់ដំណើរការភ្លាមៗ។',revokeConfirmTitle:'ដក Token?',revokeConfirmText:'ក្រោយដក bot មិនអាចប្រើ API រហូតដល់ចេញ Token ថ្មី។',rotateToken:'ចេញ Token ថ្មី',issueToken:'បង្កើត Token ថ្មី',revokeToken:'ដក Token',sessionExpired:'ការចូលបានផុតកំណត់។ សូមចូលម្តងទៀត។',usernameExists:'ឈ្មោះ bot នេះត្រូវបានប្រើរួច។',limitError:'បានដល់ចំនួន bot កំណត់។',notFound:'រកមិនឃើញ bot នេះ។',validationError:'សូមពិនិត្យឈ្មោះ និងទម្រង់ឈ្មោះអ្នកប្រើ។',requestFailed:'សេវាគ្រប់គ្រង bot មិនអាចដំណើរការបានឥឡូវនេះ។',invalidDisplayName:'ឈ្មោះ bot ត្រូវមាន 1–64 តួអក្សរ។',invalidUsername:'ឈ្មោះអ្នកប្រើត្រូវមាន 7–32 អក្សរ លេខ ឬ _ និងបញ្ចប់ដោយ bot។',created:'បានបង្កើត bot។ សូមរក្សាទុក Token ឥឡូវនេះ។',tokenIssued:'បានចេញ Token ថ្មី ហើយ Token ចាស់អស់សុពលភាព។',tokenRevoked:'បានដក Token។',tokenCopied:'បានចម្លង Token។',copyFailed:'ចម្លង Token មិនបាន។ សូមចម្លងដោយដៃ។',openManager:'បើកកម្មវិធីគ្រប់គ្រង BotMother',open:'គ្រប់គ្រង bot'
  },
  lo: {
    managerTitle:'ຈັດການ BotMother',back:'ກັບຄືນ',description:'ສ້າງບັນຊີ bot ແລະຈັດການ Token ກັບສະຖານະ bot ຂອງທ່ານ.',searchPlaceholder:'ຄົ້ນຫາ bot',myBots:'Bot ຂອງຂ້ອຍ',createNew:'ສ້າງ bot ໃໝ່',limitReached:'ຮອດຂີດຈຳກັດ {count} bot',createHint:'ຕັ້ງຊື່ແລະ username ທີ່ບໍ່ຊ້ຳ',active:'ເຮັດວຽກຢູ່',revoked:'ຖອນ Token ແລ້ວ',noResults:'ບໍ່ພົບ bot',tryAnother:'ລອງຄຳຄົ້ນອື່ນ.',noBots:'ຍັງບໍ່ມີ bot',noBotsHint:'ກົດ “ສ້າງ bot ໃໝ່” ເພື່ອເລີ່ມ.',createTitle:'ສ້າງ bot',createDescription:'ໃສ່ຊື່ສະແດງ ແລະ username ສາທາລະນະ. Token ສະແດງພຽງຄັ້ງດຽວ.',displayName:'ຊື່ສະແດງ',displayNamePlaceholder:'ຕົວຢ່າງ: ຜູ້ຊ່ວຍແຈ້ງເຕືອນ',displayNameHint:'1–64 ຕົວອັກສອນ.',username:'Username bot',usernamePlaceholder:'order_notice_bot',usernameHint:'7–32 ຕົວອັກສອນ ຕົວເລກ ຫຼື _ ແລະຕ້ອງລົງທ້າຍ bot.',botUserId:'ID ຜູ້ໃຊ້ bot',tokenStatus:'ສະຖານະ Token',createdAt:'ສ້າງເມື່ອ',newToken:'Token bot ໃໝ່',tokenOnce:'Token ສະແດງເມື່ອສ້າງ ຫຼືອອກໃໝ່ເທົ່ານັ້ນ. ກະລຸນາສຳເນົາໄວ້ທີ່ server.',copyToken:'ສຳເນົາ Token',rotateConfirmTitle:'ອອກ Token ໃໝ່?',rotateConfirmText:'Token ເກົ່າຈະໃຊ້ບໍ່ໄດ້ທັນທີ.',revokeConfirmTitle:'ຖອນ Token?',revokeConfirmText:'ຫຼັງຖອນ bot ຈະໃຊ້ API ບໍ່ໄດ້ຈົນກວ່າອອກ Token ໃໝ່.',rotateToken:'ອອກ Token ໃໝ່',issueToken:'ສ້າງ Token ໃໝ່',revokeToken:'ຖອນ Token',sessionExpired:'ການເຂົ້າລະບົບໝົດອາຍຸ. ກະລຸນາເຂົ້າໃໝ່.',usernameExists:'Username bot ນີ້ຖືກໃຊ້ແລ້ວ.',limitError:'ຮອດຈຳນວນ bot ສູງສຸດແລ້ວ.',notFound:'ບໍ່ພົບ bot ນີ້.',validationError:'ກະລຸນາກວດຊື່ ແລະຮູບແບບ username.',requestFailed:'ບໍລິການຈັດການ bot ຍັງບໍ່ພ້ອມ.',invalidDisplayName:'ຊື່ bot ຕ້ອງມີ 1–64 ຕົວອັກສອນ.',invalidUsername:'Username ຕ້ອງມີ 7–32 ຕົວອັກສອນ ຕົວເລກ ຫຼື _ ແລະລົງທ້າຍ bot.',created:'ສ້າງ bot ແລ້ວ. ກະລຸນາເກັບ Token ດຽວນີ້.',tokenIssued:'ອອກ Token ໃໝ່ແລ້ວ ແລະ Token ເກົ່າໃຊ້ບໍ່ໄດ້.',tokenRevoked:'ຖອນ Token ແລ້ວ.',tokenCopied:'ສຳເນົາ Token ແລ້ວ.',copyFailed:'ສຳເນົາ Token ບໍ່ສຳເລັດ. ກະລຸນາສຳເນົາເອງ.',openManager:'ເປີດຕົວຈັດການ BotMother',open:'ຈັດການ bot'
  },
  th: {
    managerTitle:'จัดการ BotMother',back:'กลับ',description:'สร้างบัญชีบอตและจัดการ Token กับสถานะของบอตที่มีอยู่',searchPlaceholder:'ค้นหาบอต',myBots:'บอตของฉัน',createNew:'สร้างบอตใหม่',limitReached:'ถึงขีดจำกัด {count} บอตแล้ว',createHint:'ตั้งชื่อและชื่อผู้ใช้ที่ไม่ซ้ำ',active:'ใช้งานอยู่',revoked:'เพิกถอน Token แล้ว',noResults:'ไม่พบบอตที่ตรงกัน',tryAnother:'ลองใช้คำค้นอื่น',noBots:'ยังไม่มีบอต',noBotsHint:'กด “สร้างบอตใหม่” เพื่อเริ่มต้น',createTitle:'สร้างบอต',createDescription:'กรอกชื่อที่แสดงและชื่อผู้ใช้สาธารณะ Token จะแสดงเพียงครั้งเดียวหลังสร้าง',displayName:'ชื่อที่แสดง',displayNamePlaceholder:'เช่น ผู้ช่วยแจ้งเตือนคำสั่งซื้อ',displayNameHint:'อักขระที่มองเห็นได้ 1–64 ตัว',username:'ชื่อผู้ใช้บอต',usernamePlaceholder:'order_notice_bot',usernameHint:'ตัวอักษร ตัวเลข หรือ _ จำนวน 7–32 ตัว และต้องลงท้ายด้วย bot',botUserId:'ID ผู้ใช้บอต',tokenStatus:'สถานะ Token',createdAt:'สร้างเมื่อ',newToken:'Token บอตใหม่',tokenOnce:'Token จะแสดงตอนสร้างหรือออกใหม่เท่านั้น โปรดคัดลอกและเก็บไว้บนเซิร์ฟเวอร์',copyToken:'คัดลอก Token',rotateConfirmTitle:'ออก Token ใหม่?',rotateConfirmText:'Token เก่าจะใช้ไม่ได้ทันที รวมถึงบริการที่ยังใช้ Token เก่า',revokeConfirmTitle:'เพิกถอน Token?',revokeConfirmText:'หลังเพิกถอน บอตจะเรียก API ไม่ได้จนกว่าจะออก Token ใหม่',rotateToken:'ออก Token ใหม่',issueToken:'สร้าง Token ใหม่',revokeToken:'เพิกถอน Token',sessionExpired:'สถานะเข้าสู่ระบบหมดอายุ โปรดเข้าสู่ระบบใหม่',usernameExists:'ชื่อผู้ใช้บอตนี้ถูกใช้แล้ว',limitError:'ถึงจำนวนบอตสูงสุดแล้ว',notFound:'ไม่พบบอตนี้',validationError:'โปรดตรวจสอบชื่อบอตและรูปแบบชื่อผู้ใช้',requestFailed:'บริการจัดการบอตยังไม่สามารถดำเนินการได้',invalidDisplayName:'ชื่อบอตต้องมีอักขระที่มองเห็นได้ 1–64 ตัว',invalidUsername:'ชื่อผู้ใช้ต้องมีตัวอักษร ตัวเลข หรือ _ จำนวน 7–32 ตัว และลงท้ายด้วย bot',created:'สร้างบอตแล้ว โปรดบันทึก Token ทันที',tokenIssued:'ออก Token ใหม่แล้ว และ Token เก่าใช้ไม่ได้แล้ว',tokenRevoked:'เพิกถอน Token แล้ว',tokenCopied:'คัดลอก Token แล้ว',copyFailed:'คัดลอก Token ไม่สำเร็จ โปรดเลือกและคัดลอกเอง',openManager:'เปิดตัวจัดการบอต BotMother',open:'จัดการบอต'
  },
  vi: {
    managerTitle:'Quản lý BotMother',back:'Quay lại',description:'Tạo tài khoản bot và quản lý Token cùng trạng thái của các bot hiện có.',searchPlaceholder:'Tìm bot',myBots:'Bot của tôi',createNew:'Tạo bot mới',limitReached:'Đã đạt giới hạn {count} bot',createHint:'Đặt tên và tên người dùng duy nhất',active:'Đang hoạt động',revoked:'Đã thu hồi Token',noResults:'Không tìm thấy bot phù hợp',tryAnother:'Hãy thử từ khóa khác.',noBots:'Chưa có bot',noBotsHint:'Chọn “Tạo bot mới” để bắt đầu.',createTitle:'Tạo bot',createDescription:'Nhập tên hiển thị và tên người dùng công khai. Token chỉ hiển thị một lần sau khi tạo.',displayName:'Tên hiển thị',displayNamePlaceholder:'Ví dụ: Trợ lý thông báo đơn hàng',displayNameHint:'1–64 ký tự hiển thị.',username:'Tên người dùng bot',usernamePlaceholder:'order_notice_bot',usernameHint:'7–32 chữ cái, số hoặc dấu _ và phải kết thúc bằng bot.',botUserId:'ID người dùng bot',tokenStatus:'Trạng thái Token',createdAt:'Thời gian tạo',newToken:'Token bot mới',tokenOnce:'Token chỉ hiển thị khi tạo hoặc cấp lại. Hãy sao chép ngay và lưu an toàn trên máy chủ.',copyToken:'Sao chép Token',rotateConfirmTitle:'Cấp lại Token?',rotateConfirmText:'Token cũ sẽ mất hiệu lực ngay, kể cả các dịch vụ vẫn đang dùng nó.',revokeConfirmTitle:'Thu hồi Token?',revokeConfirmText:'Sau khi thu hồi, bot không thể gọi API cho đến khi được cấp Token mới.',rotateToken:'Cấp lại Token',issueToken:'Cấp Token mới',revokeToken:'Thu hồi Token',sessionExpired:'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.',usernameExists:'Tên người dùng bot này đã được sử dụng.',limitError:'Đã đạt giới hạn số bot.',notFound:'Không tìm thấy bot này.',validationError:'Hãy kiểm tra tên bot và định dạng tên người dùng.',requestFailed:'Dịch vụ quản lý bot tạm thời không thể xử lý yêu cầu.',invalidDisplayName:'Tên bot phải có 1–64 ký tự hiển thị.',invalidUsername:'Tên người dùng phải có 7–32 chữ cái, số hoặc dấu _ và kết thúc bằng bot.',created:'Đã tạo bot. Hãy lưu Token ngay.',tokenIssued:'Đã cấp Token mới và Token cũ không còn hiệu lực.',tokenRevoked:'Đã thu hồi Token.',tokenCopied:'Đã sao chép Token.',copyFailed:'Không thể sao chép Token. Hãy chọn và sao chép thủ công.',openManager:'Mở trình quản lý bot BotMother',open:'Quản lý bot'
  }
};
Object.entries(botMotherMessages).forEach(([locale, values]) => {
  Object.entries(values).forEach(([key, value]) => { messages[locale][`botMother.${key}`] = value; });
});

const botMotherUsernameCheckMessages = {
  zh_hans: {
    usernamePlaceholder:'例如：order_notice',usernameHint:'输入 3–28 个英文字母、数字或下划线，须以字母开头；系统会自动加上 _bot。',fixedSuffix:'固定后缀 _bot',checkUsername:'检查',checkingUsername:'检查中…',usernameAvailable:'这个机器人用户名可以使用。',usernameNeedsCheck:'请先检查机器人用户名是否可用。',usernameChanged:'用户名已修改，请重新检查。',invalidUsernamePrefix:'请输入 3–28 个英文字母、数字或下划线，并以字母开头。'
  },
  zh_hant: {
    usernamePlaceholder:'例如：order_notice',usernameHint:'輸入 3–28 個英文字母、數字或底線，須以字母開頭；系統會自動加上 _bot。',fixedSuffix:'固定後綴 _bot',checkUsername:'檢查',checkingUsername:'檢查中…',usernameAvailable:'這個機器人使用者名稱可以使用。',usernameNeedsCheck:'請先檢查機器人使用者名稱是否可用。',usernameChanged:'使用者名稱已修改，請重新檢查。',invalidUsernamePrefix:'請輸入 3–28 個英文字母、數字或底線，並以字母開頭。'
  },
  en: {
    usernamePlaceholder:'For example: order_notice',usernameHint:'Enter 3–28 letters, numbers, or underscores, starting with a letter. The _bot suffix is added automatically.',fixedSuffix:'Fixed suffix _bot',checkUsername:'Check',checkingUsername:'Checking…',usernameAvailable:'This bot username is available.',usernameNeedsCheck:'Check whether this bot username is available first.',usernameChanged:'The username changed. Check it again.',invalidUsernamePrefix:'Enter 3–28 letters, numbers, or underscores, starting with a letter.'
  },
  km: {
    usernamePlaceholder:'ឧ. order_notice',usernameHint:'បញ្ចូល 3–28 អក្សរ លេខ ឬ _ ហើយចាប់ផ្តើមដោយអក្សរ។ ប្រព័ន្ធបន្ថែម _bot ដោយស្វ័យប្រវត្តិ។',fixedSuffix:'បច្ច័យថេរ _bot',checkUsername:'ពិនិត្យ',checkingUsername:'កំពុងពិនិត្យ…',usernameAvailable:'ឈ្មោះ bot នេះអាចប្រើបាន។',usernameNeedsCheck:'សូមពិនិត្យឈ្មោះ bot ជាមុន។',usernameChanged:'ឈ្មោះបានផ្លាស់ប្តូរ សូមពិនិត្យម្តងទៀត។',invalidUsernamePrefix:'បញ្ចូល 3–28 អក្សរ លេខ ឬ _ ហើយចាប់ផ្តើមដោយអក្សរ។'
  },
  lo: {
    usernamePlaceholder:'ຕົວຢ່າງ: order_notice',usernameHint:'ໃສ່ 3–28 ຕົວອັກສອນ ຕົວເລກ ຫຼື _ ແລະເລີ່ມດ້ວຍຕົວອັກສອນ. ລະບົບຈະເພີ່ມ _bot ອັດຕະໂນມັດ.',fixedSuffix:'ຄຳຕໍ່ທ້າຍຄົງທີ່ _bot',checkUsername:'ກວດສອບ',checkingUsername:'ກຳລັງກວດ…',usernameAvailable:'ຊື່ bot ນີ້ໃຊ້ໄດ້.',usernameNeedsCheck:'ກວດສອບຊື່ bot ກ່ອນ.',usernameChanged:'ຊື່ຖືກປ່ຽນແລ້ວ ກະລຸນາກວດອີກຄັ້ງ.',invalidUsernamePrefix:'ໃສ່ 3–28 ຕົວອັກສອນ ຕົວເລກ ຫຼື _ ແລະເລີ່ມດ້ວຍຕົວອັກສອນ.'
  },
  th: {
    usernamePlaceholder:'เช่น order_notice',usernameHint:'กรอกตัวอักษร ตัวเลข หรือ _ จำนวน 3–28 ตัว โดยขึ้นต้นด้วยตัวอักษร ระบบจะเติม _bot ให้อัตโนมัติ',fixedSuffix:'ส่วนท้ายคงที่ _bot',checkUsername:'ตรวจสอบ',checkingUsername:'กำลังตรวจสอบ…',usernameAvailable:'ชื่อผู้ใช้บอตนี้ใช้งานได้',usernameNeedsCheck:'โปรดตรวจสอบชื่อผู้ใช้บอตก่อน',usernameChanged:'ชื่อผู้ใช้ถูกแก้ไข โปรดตรวจสอบอีกครั้ง',invalidUsernamePrefix:'กรอกตัวอักษร ตัวเลข หรือ _ จำนวน 3–28 ตัว และขึ้นต้นด้วยตัวอักษร'
  },
  vi: {
    usernamePlaceholder:'Ví dụ: order_notice',usernameHint:'Nhập 3–28 chữ cái, số hoặc dấu _, bắt đầu bằng chữ cái. Hệ thống tự thêm hậu tố _bot.',fixedSuffix:'Hậu tố cố định _bot',checkUsername:'Kiểm tra',checkingUsername:'Đang kiểm tra…',usernameAvailable:'Tên bot này có thể sử dụng.',usernameNeedsCheck:'Hãy kiểm tra tên bot trước.',usernameChanged:'Tên đã thay đổi. Hãy kiểm tra lại.',invalidUsernamePrefix:'Nhập 3–28 chữ cái, số hoặc dấu _, bắt đầu bằng chữ cái.'
  }
};
Object.entries(botMotherUsernameCheckMessages).forEach(([locale, values]) => {
  Object.entries(values).forEach(([key, value]) => { messages[locale][`botMother.${key}`] = value; });
});

const botSettingsMessages = {
  zh_hans: {
    title:'机器人设置',back:'返回',ownerOnly:'只有机器人拥有者可以查看并修改这些设置。',joinedGroups:'加入群列表',joinedGroupsSummary:'已加入 {count} 个群',preferences:'设置',preferencesSummary:'入群审批与外部程序连接',autoReply:'自动回复设置',autoReplySummary:'已建立 {count} 条关键字规则',groupsHint:'选择群组后，可决定机器人是否接收该群消息。',pendingInvites:'等待同意的入群邀请',reject:'拒绝',approve:'同意',memberCount:'{count} 位成员',receiving:'接收中',notReceiving:'已关闭',noGroups:'尚未加入群组',noGroupsHint:'机器人被加入群后会显示在这里。',groupSettings:'群组设置',receiveGroupMessages:'接收这个群的消息',receiveGroupMessagesHint:'关闭后，不转发消息、不提供外部更新，也不执行群内自动回复。',groupForwardHint:'开启后，群消息会持续转发到你与机器人的对话，并在消息前显示群名称。',preferencesHint:'控制入群审批，以及 Token 是否允许外部程序调用。',requireApproval:'加入群组前需要我同意',requireApprovalHint:'默认开启。邀请会先进入等待处理列表。',externalAccess:'允许外部程序连接使用',externalAccessHint:'默认开启。允许 getMe、getUpdates 与 sendMessage。',externalDisabledWarning:'关闭后，现有 Token 会保留，但外部程序的 API 请求会被拒绝。',autoReplyHint:'收到的文字包含关键字时，机器人发送对应回复。优先匹配列表中较前面的规则。',addRule:'新增关键字规则',enabled:'已启用',disabled:'已停用',noRules:'尚无自动回复规则',noRulesHint:'新增规则后，私聊与已开启接收的群聊都会生效。',aiReply:'AI API 自动回复',aiReplyPlanned:'后续版本将提供接入第三方 AI API 的设置；目前只显示功能说明。',planned:'规划中',editRule:'编辑关键字规则',ruleHint:'关键字采用“包含”匹配，不区分英文字母大小写。',keyword:'关键字',keywordPlaceholder:'例如：营业时间',keywordHint:'1–100 个字。',replyText:'回复内容',replyPlaceholder:'输入机器人要发送的回复',replyHint:'1–2000 个字。',ruleEnabled:'启用这条规则',deleteRule:'删除规则',deleteRuleConfirm:'确定删除这条自动回复规则吗？删除后无法恢复。',loadFailed:'机器人设置读取失败',requestFailed:'机器人设置暂时无法处理请求。',preferencesSaved:'机器人设置已保存。',groupSaved:'群组接收设置已保存。',inviteApproved:'已同意机器人加入群组。',inviteRejected:'已拒绝这次入群邀请。',ruleSaved:'自动回复规则已保存。',ruleDeleted:'自动回复规则已删除。'
  },
  zh_hant: {
    title:'機器人設定',back:'返回',ownerOnly:'只有機器人擁有者可以查看並修改這些設定。',joinedGroups:'加入群組列表',joinedGroupsSummary:'已加入 {count} 個群組',preferences:'設定',preferencesSummary:'入群審批與外部程式連線',autoReply:'自動回覆設定',autoReplySummary:'已建立 {count} 條關鍵字規則',groupsHint:'選擇群組後，可決定機器人是否接收該群訊息。',pendingInvites:'等待同意的入群邀請',reject:'拒絕',approve:'同意',memberCount:'{count} 位成員',receiving:'接收中',notReceiving:'已關閉',noGroups:'尚未加入群組',noGroupsHint:'機器人被加入群組後會顯示在這裡。',groupSettings:'群組設定',receiveGroupMessages:'接收這個群組的訊息',receiveGroupMessagesHint:'關閉後，不轉發訊息、不提供外部更新，也不執行群內自動回覆。',groupForwardHint:'開啟後，群訊息會持續轉發到你與機器人的對話，並在訊息前顯示群組名稱。',preferencesHint:'控制入群審批，以及 Token 是否允許外部程式呼叫。',requireApproval:'加入群組前需要我同意',requireApprovalHint:'預設開啟。邀請會先進入等待處理列表。',externalAccess:'允許外部程式連線使用',externalAccessHint:'預設開啟。允許 getMe、getUpdates 與 sendMessage。',externalDisabledWarning:'關閉後，現有 Token 會保留，但外部程式的 API 請求會被拒絕。',autoReplyHint:'收到的文字包含關鍵字時，機器人傳送對應回覆。優先比對列表中較前面的規則。',addRule:'新增關鍵字規則',enabled:'已啟用',disabled:'已停用',noRules:'尚無自動回覆規則',noRulesHint:'新增規則後，私聊與已開啟接收的群聊都會生效。',aiReply:'AI API 自動回覆',aiReplyPlanned:'後續版本將提供接入第三方 AI API 的設定；目前只顯示功能說明。',planned:'規劃中',editRule:'編輯關鍵字規則',ruleHint:'關鍵字採用「包含」比對，不區分英文字母大小寫。',keyword:'關鍵字',keywordPlaceholder:'例如：營業時間',keywordHint:'1–100 個字。',replyText:'回覆內容',replyPlaceholder:'輸入機器人要傳送的回覆',replyHint:'1–2000 個字。',ruleEnabled:'啟用這條規則',deleteRule:'刪除規則',deleteRuleConfirm:'確定刪除這條自動回覆規則嗎？刪除後無法復原。',loadFailed:'機器人設定讀取失敗',requestFailed:'機器人設定暫時無法處理請求。',preferencesSaved:'機器人設定已儲存。',groupSaved:'群組接收設定已儲存。',inviteApproved:'已同意機器人加入群組。',inviteRejected:'已拒絕這次入群邀請。',ruleSaved:'自動回覆規則已儲存。',ruleDeleted:'自動回覆規則已刪除。'
  },
  en: {
    title:'Bot settings',back:'Back',ownerOnly:'Only the bot owner can view and change these settings.',joinedGroups:'Joined groups',joinedGroupsSummary:'Joined {count} groups',preferences:'Settings',preferencesSummary:'Group approval and external access',autoReply:'Auto replies',autoReplySummary:'{count} keyword rules',groupsHint:'Select a group to choose whether the bot receives its messages.',pendingInvites:'Group invitations awaiting approval',reject:'Reject',approve:'Approve',memberCount:'{count} members',receiving:'Receiving',notReceiving:'Off',noGroups:'No joined groups',noGroupsHint:'Groups appear here after the bot is added.',groupSettings:'Group settings',receiveGroupMessages:'Receive messages from this group',receiveGroupMessagesHint:'When off, messages are not forwarded or sent to external updates, and group auto replies do not run.',groupForwardHint:'When enabled, group messages are forwarded to your chat with the bot and prefixed with the group name.',preferencesHint:'Control group invitation approval and whether the token can be used by external programs.',requireApproval:'Require my approval before joining groups',requireApprovalHint:'On by default. Invitations wait here for your decision.',externalAccess:'Allow external program access',externalAccessHint:'On by default. Enables getMe, getUpdates, and sendMessage.',externalDisabledWarning:'The current token is kept, but external API requests are rejected while this is off.',autoReplyHint:'When incoming text contains a keyword, the bot sends its reply. Earlier rules take priority.',addRule:'Add keyword rule',enabled:'Enabled',disabled:'Disabled',noRules:'No auto reply rules',noRulesHint:'Rules apply to private chats and groups where receiving is enabled.',aiReply:'AI API replies',aiReplyPlanned:'A future release will add third-party AI API settings. This is currently a feature description only.',planned:'Planned',editRule:'Edit keyword rule',ruleHint:'Keywords use case-insensitive “contains” matching.',keyword:'Keyword',keywordPlaceholder:'For example: business hours',keywordHint:'1–100 characters.',replyText:'Reply text',replyPlaceholder:'Enter the reply the bot should send',replyHint:'1–2000 characters.',ruleEnabled:'Enable this rule',deleteRule:'Delete rule',deleteRuleConfirm:'Delete this auto reply rule? This cannot be undone.',loadFailed:'Could not load bot settings',requestFailed:'Bot settings cannot process this request right now.',preferencesSaved:'Bot settings saved.',groupSaved:'Group receiving setting saved.',inviteApproved:'The bot was approved to join the group.',inviteRejected:'The group invitation was rejected.',ruleSaved:'Auto reply rule saved.',ruleDeleted:'Auto reply rule deleted.'
  },
  km: {
    title:'ការកំណត់ bot',back:'ត្រឡប់',ownerOnly:'មានតែម្ចាស់ bot ប៉ុណ្ណោះដែលអាចមើល និងកែការកំណត់ទាំងនេះ។',joinedGroups:'ក្រុមដែលបានចូល',joinedGroupsSummary:'បានចូល {count} ក្រុម',preferences:'ការកំណត់',preferencesSummary:'ការអនុម័តចូលក្រុម និងការតភ្ជាប់ខាងក្រៅ',autoReply:'ឆ្លើយតបស្វ័យប្រវត្តិ',autoReplySummary:'មានច្បាប់ពាក្យគន្លឹះ {count}',groupsHint:'ជ្រើសក្រុមដើម្បីកំណត់ថា bot ទទួលសារឬអត់។',pendingInvites:'ការអញ្ជើញកំពុងរង់ចាំ',reject:'បដិសេធ',approve:'យល់ព្រម',memberCount:'សមាជិក {count} នាក់',receiving:'កំពុងទទួល',notReceiving:'បានបិទ',noGroups:'មិនទាន់ចូលក្រុម',noGroupsHint:'ក្រុមនឹងបង្ហាញនៅទីនេះពេល bot ត្រូវបានបន្ថែម។',groupSettings:'ការកំណត់ក្រុម',receiveGroupMessages:'ទទួលសារពីក្រុមនេះ',receiveGroupMessagesHint:'ពេលបិទ សារមិនត្រូវបានបញ្ជូន មិនមាន external updates និងមិនឆ្លើយស្វ័យប្រវត្តិក្នុងក្រុម។',groupForwardHint:'ពេលបើក សារក្រុមនឹងបញ្ជូនមកការជជែករបស់អ្នកជាមួយ bot ដោយបន្ថែមឈ្មោះក្រុមនៅខាងមុខ។',preferencesHint:'គ្រប់គ្រងការអនុម័តចូលក្រុម និងការប្រើ Token ពីកម្មវិធីខាងក្រៅ។',requireApproval:'ត្រូវការការយល់ព្រមពីខ្ញុំមុនចូលក្រុម',requireApprovalHint:'បើកតាមលំនាំដើម។ ការអញ្ជើញនឹងរង់ចាំការសម្រេច។',externalAccess:'អនុញ្ញាតកម្មវិធីខាងក្រៅ',externalAccessHint:'បើកតាមលំនាំដើមសម្រាប់ getMe, getUpdates និង sendMessage។',externalDisabledWarning:'Token នៅតែរក្សាទុក ប៉ុន្តែ API ខាងក្រៅនឹងត្រូវបដិសេធ។',autoReplyHint:'ពេលសារមានពាក្យគន្លឹះ bot នឹងផ្ញើចម្លើយដែលបានកំណត់។',addRule:'បន្ថែមច្បាប់ពាក្យគន្លឹះ',enabled:'បានបើក',disabled:'បានបិទ',noRules:'មិនទាន់មានច្បាប់',noRulesHint:'ច្បាប់អនុវត្តលើសារផ្ទាល់ និងក្រុមដែលបានបើកការទទួល។',aiReply:'ការឆ្លើយតប AI API',aiReplyPlanned:'ការកំណត់ AI API ភាគីទីបីនឹងមាននៅកំណែក្រោយ។ ឥឡូវនេះគ្រាន់តែជាការពិពណ៌នា។',planned:'គ្រោងទុក',editRule:'កែច្បាប់',ruleHint:'ពាក្យគន្លឹះត្រូវផ្គូផ្គងបែបមាននៅក្នុងសារ ដោយមិនគិតអក្សរធំតូច។',keyword:'ពាក្យគន្លឹះ',keywordPlaceholder:'ឧ. ម៉ោងធ្វើការ',keywordHint:'1–100 តួអក្សរ។',replyText:'អត្ថបទឆ្លើយតប',replyPlaceholder:'បញ្ចូលចម្លើយរបស់ bot',replyHint:'1–2000 តួអក្សរ។',ruleEnabled:'បើកច្បាប់នេះ',deleteRule:'លុបច្បាប់',deleteRuleConfirm:'លុបច្បាប់ឆ្លើយតបនេះ? មិនអាចស្តារវិញបានទេ។',loadFailed:'មិនអាចផ្ទុកការកំណត់ bot',requestFailed:'សេវាការកំណត់ bot មិនអាចដំណើរការសំណើឥឡូវនេះ។',preferencesSaved:'បានរក្សាទុកការកំណត់ bot។',groupSaved:'បានរក្សាទុកការទទួលសារក្រុម។',inviteApproved:'បានយល់ព្រមឱ្យ bot ចូលក្រុម។',inviteRejected:'បានបដិសេធការអញ្ជើញចូលក្រុម។',ruleSaved:'បានរក្សាទុកច្បាប់ឆ្លើយតប។',ruleDeleted:'បានលុបច្បាប់ឆ្លើយតប។'
  },
  lo: {
    title:'ການຕັ້ງຄ່າ bot',back:'ກັບຄືນ',ownerOnly:'ສະເພາະເຈົ້າຂອງ bot ເທົ່ານັ້ນທີ່ເບິ່ງ ແລະແກ້ໄຂໄດ້.',joinedGroups:'ກຸ່ມທີ່ເຂົ້າຮ່ວມ',joinedGroupsSummary:'ເຂົ້າແລ້ວ {count} ກຸ່ມ',preferences:'ການຕັ້ງຄ່າ',preferencesSummary:'ອະນຸມັດເຂົ້າກຸ່ມ ແລະໂປຣແກຣມພາຍນອກ',autoReply:'ຕອບອັດຕະໂນມັດ',autoReplySummary:'ມີ {count} ກົດຄຳສຳຄັນ',groupsHint:'ເລືອກກຸ່ມເພື່ອກຳນົດວ່າ bot ຈະຮັບຂໍ້ຄວາມຫຼືບໍ່.',pendingInvites:'ຄຳເຊີນທີ່ລໍຖ້າ',reject:'ປະຕິເສດ',approve:'ຍອມຮັບ',memberCount:'{count} ສະມາຊິກ',receiving:'ກຳລັງຮັບ',notReceiving:'ປິດແລ້ວ',noGroups:'ຍັງບໍ່ມີກຸ່ມ',noGroupsHint:'ກຸ່ມຈະສະແດງຫຼັງຈາກເພີ່ມ bot.',groupSettings:'ຕັ້ງຄ່າກຸ່ມ',receiveGroupMessages:'ຮັບຂໍ້ຄວາມຈາກກຸ່ມນີ້',receiveGroupMessagesHint:'ເມື່ອປິດ ຈະບໍ່ສົ່ງຕໍ່, ບໍ່ມີ external updates ແລະບໍ່ຕອບອັດຕະໂນມັດ.',groupForwardHint:'ເມື່ອເປີດ ຂໍ້ຄວາມກຸ່ມຈະສົ່ງເຂົ້າແຊັດກັບ bot ພ້ອມຊື່ກຸ່ມ.',preferencesHint:'ຄວບຄຸມການອະນຸມັດ ແລະການໃຊ້ Token ຈາກພາຍນອກ.',requireApproval:'ຕ້ອງໃຫ້ຂ້ອຍອະນຸມັດກ່ອນເຂົ້າກຸ່ມ',requireApprovalHint:'ເປີດເປັນຄ່າຕັ້ງຕົ້ນ. ຄຳເຊີນຈະລໍຖ້າການຕັດສິນ.',externalAccess:'ອະນຸຍາດໂປຣແກຣມພາຍນອກ',externalAccessHint:'ເປີດເປັນຄ່າຕັ້ງຕົ້ນສຳລັບ getMe, getUpdates ແລະ sendMessage.',externalDisabledWarning:'Token ຍັງຢູ່ ແຕ່ API ພາຍນອກຈະຖືກປະຕິເສດ.',autoReplyHint:'ເມື່ອຂໍ້ຄວາມມີຄຳສຳຄັນ bot ຈະສົ່ງຄຳຕອບ.',addRule:'ເພີ່ມກົດຄຳສຳຄັນ',enabled:'ເປີດແລ້ວ',disabled:'ປິດແລ້ວ',noRules:'ຍັງບໍ່ມີກົດ',noRulesHint:'ກົດໃຊ້ກັບແຊັດສ່ວນຕົວ ແລະກຸ່ມທີ່ເປີດຮັບ.',aiReply:'ຕອບດ້ວຍ AI API',aiReplyPlanned:'ຈະເພີ່ມການຕັ້ງຄ່າ AI API ພາຍນອກໃນລຸ້ນຕໍ່ໄປ. ຕອນນີ້ເປັນຄຳອະທິບາຍ.',planned:'ວາງແຜນໄວ້',editRule:'ແກ້ໄຂກົດ',ruleHint:'ຄຳສຳຄັນຈະກວດແບບມີຢູ່ໃນຂໍ້ຄວາມ ໂດຍບໍ່ແຍກຕົວພິມ.',keyword:'ຄຳສຳຄັນ',keywordPlaceholder:'ຕົວຢ່າງ: ເວລາເຮັດວຽກ',keywordHint:'1–100 ຕົວອັກສອນ.',replyText:'ຂໍ້ຄວາມຕອບ',replyPlaceholder:'ໃສ່ຄຳຕອບຂອງ bot',replyHint:'1–2000 ຕົວອັກສອນ.',ruleEnabled:'ເປີດກົດນີ້',deleteRule:'ລຶບກົດ',deleteRuleConfirm:'ລຶບກົດນີ້ບໍ? ບໍ່ສາມາດກູ້ຄືນ.',loadFailed:'ໂຫຼດການຕັ້ງຄ່າ bot ບໍ່ໄດ້',requestFailed:'ບໍລິການຕັ້ງຄ່າ bot ຍັງບໍ່ສາມາດດຳເນີນຄຳຂໍ.',preferencesSaved:'ບັນທຶກການຕັ້ງຄ່າແລ້ວ.',groupSaved:'ບັນທຶກການຮັບຂໍ້ຄວາມກຸ່ມແລ້ວ.',inviteApproved:'ອະນຸມັດໃຫ້ bot ເຂົ້າກຸ່ມແລ້ວ.',inviteRejected:'ປະຕິເສດຄຳເຊີນແລ້ວ.',ruleSaved:'ບັນທຶກກົດແລ້ວ.',ruleDeleted:'ລຶບກົດແລ້ວ.'
  },
  th: {
    title:'การตั้งค่าบอต',back:'กลับ',ownerOnly:'เฉพาะเจ้าของบอตเท่านั้นที่ดูและแก้ไขการตั้งค่าเหล่านี้ได้',joinedGroups:'กลุ่มที่เข้าร่วม',joinedGroupsSummary:'เข้าร่วมแล้ว {count} กลุ่ม',preferences:'การตั้งค่า',preferencesSummary:'อนุมัติเข้ากลุ่มและการเชื่อมต่อภายนอก',autoReply:'ตอบกลับอัตโนมัติ',autoReplySummary:'มีกฎคำสำคัญ {count} ข้อ',groupsHint:'เลือกกลุ่มเพื่อกำหนดว่าบอตจะรับข้อความหรือไม่',pendingInvites:'คำเชิญเข้ากลุ่มที่รออนุมัติ',reject:'ปฏิเสธ',approve:'อนุมัติ',memberCount:'สมาชิก {count} คน',receiving:'กำลังรับ',notReceiving:'ปิดแล้ว',noGroups:'ยังไม่ได้เข้ากลุ่ม',noGroupsHint:'กลุ่มจะแสดงที่นี่หลังเพิ่มบอต',groupSettings:'การตั้งค่ากลุ่ม',receiveGroupMessages:'รับข้อความจากกลุ่มนี้',receiveGroupMessagesHint:'เมื่อปิด จะไม่ส่งต่อข้อความ ไม่ส่ง external updates และไม่ตอบอัตโนมัติในกลุ่ม',groupForwardHint:'เมื่อเปิด ข้อความกลุ่มจะส่งต่อมายังแชตกับบอตพร้อมชื่อกลุ่มด้านหน้า',preferencesHint:'ควบคุมการอนุมัติเข้ากลุ่มและการใช้ Token จากโปรแกรมภายนอก',requireApproval:'ต้องให้ฉันอนุมัติก่อนเข้ากลุ่ม',requireApprovalHint:'เปิดเป็นค่าเริ่มต้น คำเชิญจะรอการตัดสินใจ',externalAccess:'อนุญาตโปรแกรมภายนอก',externalAccessHint:'เปิดเป็นค่าเริ่มต้นสำหรับ getMe, getUpdates และ sendMessage',externalDisabledWarning:'Token เดิมยังอยู่ แต่คำขอ API ภายนอกจะถูกปฏิเสธ',autoReplyHint:'เมื่อข้อความมีคำสำคัญ บอตจะส่งคำตอบที่กำหนด โดยกฎด้านบนมีลำดับก่อน',addRule:'เพิ่มกฎคำสำคัญ',enabled:'เปิดใช้งาน',disabled:'ปิดใช้งาน',noRules:'ยังไม่มีกฎตอบกลับ',noRulesHint:'กฎใช้กับแชตส่วนตัวและกลุ่มที่เปิดรับข้อความ',aiReply:'ตอบกลับด้วย AI API',aiReplyPlanned:'เวอร์ชันถัดไปจะเพิ่มการตั้งค่า AI API ภายนอก ตอนนี้เป็นคำอธิบายฟังก์ชันเท่านั้น',planned:'อยู่ในแผน',editRule:'แก้ไขกฎ',ruleHint:'จับคู่แบบ “มีคำนี้” โดยไม่แยกตัวพิมพ์ใหญ่เล็ก',keyword:'คำสำคัญ',keywordPlaceholder:'เช่น เวลาทำการ',keywordHint:'1–100 อักขระ',replyText:'ข้อความตอบกลับ',replyPlaceholder:'กรอกคำตอบที่บอตจะส่ง',replyHint:'1–2000 อักขระ',ruleEnabled:'เปิดใช้กฎนี้',deleteRule:'ลบกฎ',deleteRuleConfirm:'ลบกฎตอบกลับนี้หรือไม่? ไม่สามารถกู้คืนได้',loadFailed:'โหลดการตั้งค่าบอตไม่สำเร็จ',requestFailed:'บริการตั้งค่าบอตยังไม่สามารถดำเนินคำขอได้',preferencesSaved:'บันทึกการตั้งค่าบอตแล้ว',groupSaved:'บันทึกการรับข้อความกลุ่มแล้ว',inviteApproved:'อนุมัติให้บอตเข้ากลุ่มแล้ว',inviteRejected:'ปฏิเสธคำเชิญเข้ากลุ่มแล้ว',ruleSaved:'บันทึกกฎตอบกลับแล้ว',ruleDeleted:'ลบกฎตอบกลับแล้ว'
  },
  vi: {
    title:'Cài đặt bot',back:'Quay lại',ownerOnly:'Chỉ chủ sở hữu bot mới có thể xem và thay đổi các cài đặt này.',joinedGroups:'Nhóm đã tham gia',joinedGroupsSummary:'Đã tham gia {count} nhóm',preferences:'Cài đặt',preferencesSummary:'Duyệt vào nhóm và kết nối bên ngoài',autoReply:'Trả lời tự động',autoReplySummary:'Có {count} quy tắc từ khóa',groupsHint:'Chọn nhóm để quyết định bot có nhận tin nhắn hay không.',pendingInvites:'Lời mời vào nhóm đang chờ duyệt',reject:'Từ chối',approve:'Đồng ý',memberCount:'{count} thành viên',receiving:'Đang nhận',notReceiving:'Đã tắt',noGroups:'Chưa tham gia nhóm',noGroupsHint:'Nhóm sẽ xuất hiện ở đây sau khi thêm bot.',groupSettings:'Cài đặt nhóm',receiveGroupMessages:'Nhận tin nhắn từ nhóm này',receiveGroupMessagesHint:'Khi tắt, tin nhắn không được chuyển tiếp, không có external updates và không tự động trả lời trong nhóm.',groupForwardHint:'Khi bật, tin nhắn nhóm được chuyển đến cuộc trò chuyện với bot và có tên nhóm ở đầu.',preferencesHint:'Kiểm soát việc duyệt vào nhóm và quyền dùng Token từ chương trình bên ngoài.',requireApproval:'Cần tôi đồng ý trước khi vào nhóm',requireApprovalHint:'Mặc định bật. Lời mời sẽ chờ bạn quyết định.',externalAccess:'Cho phép chương trình bên ngoài',externalAccessHint:'Mặc định bật cho getMe, getUpdates và sendMessage.',externalDisabledWarning:'Token hiện tại vẫn được giữ, nhưng yêu cầu API bên ngoài sẽ bị từ chối.',autoReplyHint:'Khi văn bản chứa từ khóa, bot gửi câu trả lời tương ứng. Quy tắc phía trên được ưu tiên.',addRule:'Thêm quy tắc từ khóa',enabled:'Đã bật',disabled:'Đã tắt',noRules:'Chưa có quy tắc trả lời',noRulesHint:'Quy tắc áp dụng cho chat riêng và nhóm đã bật nhận tin.',aiReply:'Trả lời bằng AI API',aiReplyPlanned:'Phiên bản sau sẽ có cài đặt AI API bên thứ ba. Hiện tại chỉ là mô tả chức năng.',planned:'Đã lên kế hoạch',editRule:'Sửa quy tắc',ruleHint:'Từ khóa được đối chiếu theo kiểu “có chứa” và không phân biệt hoa thường.',keyword:'Từ khóa',keywordPlaceholder:'Ví dụ: giờ làm việc',keywordHint:'1–100 ký tự.',replyText:'Nội dung trả lời',replyPlaceholder:'Nhập câu trả lời bot sẽ gửi',replyHint:'1–2000 ký tự.',ruleEnabled:'Bật quy tắc này',deleteRule:'Xóa quy tắc',deleteRuleConfirm:'Xóa quy tắc trả lời này? Không thể khôi phục.',loadFailed:'Không thể tải cài đặt bot',requestFailed:'Dịch vụ cài đặt bot hiện không thể xử lý yêu cầu.',preferencesSaved:'Đã lưu cài đặt bot.',groupSaved:'Đã lưu cài đặt nhận tin nhóm.',inviteApproved:'Đã đồng ý cho bot vào nhóm.',inviteRejected:'Đã từ chối lời mời vào nhóm.',ruleSaved:'Đã lưu quy tắc trả lời.',ruleDeleted:'Đã xóa quy tắc trả lời.'
  }
};
Object.entries(botSettingsMessages).forEach(([locale, values]) => {
  Object.entries(values).forEach(([key, value]) => { messages[locale][`botSettings.${key}`] = value; });
});

Object.assign(messages.km, { 'common.create':'បង្កើត', 'common.confirm':'បញ្ជាក់', 'common.loading':'កំពុងផ្ទុក' });
Object.assign(messages.lo, { 'common.create':'ສ້າງ', 'common.confirm':'ຢືນຢັນ', 'common.loading':'ກຳລັງໂຫຼດ' });
Object.assign(messages.th, { 'common.create':'สร้าง', 'common.confirm':'ยืนยัน', 'common.loading':'กำลังโหลด' });
Object.assign(messages.vi, { 'common.create':'Tạo', 'common.confirm':'Xác nhận', 'common.loading':'Đang tải' });

Object.assign(messages.zh_hans, {
  'translation.label':'AI 译文 · {language}',
  'translation.translating':'AI 正在结合上下文翻译…',
  'translation.retry':'重试翻译',
  'translation.disabled':'管理员尚未启用 AI 对话翻译，当前继续显示原文。',
  'translation.failed':'AI 翻译暂时失败，当前继续显示原文。'
});
Object.assign(messages.zh_hant, {
  'translation.label':'AI 譯文 · {language}',
  'translation.translating':'AI 正在結合上下文翻譯…',
  'translation.retry':'重試翻譯',
  'translation.disabled':'管理員尚未啟用 AI 對話翻譯，目前繼續顯示原文。',
  'translation.failed':'AI 翻譯暫時失敗，目前繼續顯示原文。'
});
Object.assign(messages.en, {
  'translation.label':'AI translation · {language}',
  'translation.translating':'AI is translating with conversation context…',
  'translation.retry':'Retry translation',
  'translation.disabled':'AI conversation translation is not enabled. The original message remains visible.',
  'translation.failed':'AI translation is temporarily unavailable. The original message remains visible.'
});
Object.assign(messages.km, {
  'translation.label':'ការបកប្រែ AI · {language}',
  'translation.translating':'AI កំពុងបកប្រែដោយយោងតាមបរិបទ…',
  'translation.retry':'សាកល្បងបកប្រែម្តងទៀត',
  'translation.disabled':'អ្នកគ្រប់គ្រងមិនទាន់បើកការបកប្រែសន្ទនា AI ទេ។ សារដើមនៅតែបង្ហាញ។',
  'translation.failed':'ការបកប្រែ AI មិនអាចប្រើបានបណ្ដោះអាសន្ន។ សារដើមនៅតែបង្ហាញ។'
});
Object.assign(messages.lo, {
  'translation.label':'ຄຳແປ AI · {language}',
  'translation.translating':'AI ກຳລັງແປໂດຍອີງໃສ່ບໍລິບົດ…',
  'translation.retry':'ລອງແປອີກຄັ້ງ',
  'translation.disabled':'ຜູ້ຄຸ້ມຄອງຍັງບໍ່ໄດ້ເປີດການແປສົນທະນາ AI. ຍັງສະແດງຂໍ້ຄວາມຕົ້ນສະບັບ.',
  'translation.failed':'ການແປ AI ໃຊ້ງານບໍ່ໄດ້ຊົ່ວຄາວ. ຍັງສະແດງຂໍ້ຄວາມຕົ້ນສະບັບ.'
});
Object.assign(messages.th, {
  'translation.label':'คำแปล AI · {language}',
  'translation.translating':'AI กำลังแปลโดยใช้บริบทการสนทนา…',
  'translation.retry':'ลองแปลอีกครั้ง',
  'translation.disabled':'ผู้ดูแลระบบยังไม่ได้เปิดการแปลบทสนทนาด้วย AI ข้อความต้นฉบับยังคงแสดงอยู่',
  'translation.failed':'การแปลด้วย AI ใช้งานไม่ได้ชั่วคราว ข้อความต้นฉบับยังคงแสดงอยู่'
});
Object.assign(messages.vi, {
  'translation.label':'Bản dịch AI · {language}',
  'translation.translating':'AI đang dịch theo ngữ cảnh cuộc trò chuyện…',
  'translation.retry':'Thử dịch lại',
  'translation.disabled':'Quản trị viên chưa bật dịch hội thoại bằng AI. Tin nhắn gốc vẫn được hiển thị.',
  'translation.failed':'Dịch bằng AI tạm thời không khả dụng. Tin nhắn gốc vẫn được hiển thị.'
});

function interpolate(template, params = {}) {
  return String(template || '').replace(/\{(\w+)\}/g, (match, key) => {
    return Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : match;
  });
}

function optionForLanguage(key) {
  return languageOptions.find(item => item.key === key) || languageOptions[0];
}

export const useLanguageStore = defineStore('language', {
  state: () => ({
    current: 'zh_hans'
  }),
  getters: {
    currentOption: state => optionForLanguage(state.current)
  },
  actions: {
    restore() {
      let nextLanguage = 'zh_hans';
      try {
        const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
        if (languageOptions.some(item => item.key === stored)) {
          nextLanguage = stored;
        }
      } catch (error) {
        nextLanguage = 'zh_hans';
      }
      this.current = nextLanguage;
      this.applyDocumentLanguage();
    },
    setLanguage(key) {
      if (!languageOptions.some(item => item.key === key)) {
        return;
      }
      this.current = key;
      try {
        window.localStorage.setItem(LANGUAGE_STORAGE_KEY, key);
      } catch (error) {
        // localStorage can be unavailable in privacy modes.
      }
      this.applyDocumentLanguage();
    },
    applyDocumentLanguage() {
      if (typeof document !== 'undefined') {
        document.documentElement.lang = this.currentOption.htmlLang;
      }
    },
    t(key, params = {}) {
      const activeMessages = messages[this.current] || {};
      const defaultMessages = messages.zh_hans;
      return interpolate(activeMessages[key] || defaultMessages[key] || key, params);
    }
  }
});
